<template>
    <div id="document" class="vx-card" @mousedown="clickMouseNotItem($event)" @contextmenu.prevent>
        <div class="vx-row height-full">
            <div class="vx-col xl:w-1/6 lg:w-1/4 sm:w-1/3 w-1/2 left-col">
                <div class="vx-row menu">
                    <div class="vx-col w-full">
                        <vs-button class="w-full" icon-pack="feather" icon="icon-refresh-cw" type="border"
                                   @click="checkAuth">{{ $t('dashboard.synchronized') }}
                        </vs-button>
                    </div>
                    <div class="vx-col w-full base px-0">
                        <vs-collapse type="margin">
                            <vs-collapse-item icon-arrow="expand_more" open>
                                <div slot="header">
                                    <span class="text-sm font-bold" style="color: #9ca3af">Base</span>
                                </div>
                                <div class="p-2 flex items-center hover:text-primary cursor-pointer base-item"
                                     @mousedown.stop="selectBaseItem(1)"
                                     :class="baseItem === 1 ? 'base-item-active text-primary' : ''">
                                    <feather-icon icon="HomeIcon" class="mr-2" svgClasses="h-5 w-5"/>
                                    <span class="text-sm font-medium">All Files</span>
                                </div>
                                <div class="p-2 flex items-center hover:text-primary cursor-pointer base-item"
                                     @mousedown.stop="selectBaseItem(2)"
                                     :class="baseItem === 2 ? 'base-item-active text-primary' : ''">
                                    <feather-icon icon="UploadCloudIcon" class="mr-2" svgClasses="h-5 w-5"/>
                                    <span class="text-sm font-medium">Recent Upload</span>
                                </div>
                                <div class="p-2 flex items-center hover:text-primary cursor-pointer base-item"
                                     @mousedown.stop="selectBaseItem(3)"
                                     :class="baseItem === 3 ? 'base-item-active text-primary' : ''">
                                    <feather-icon icon="LinkIcon" class="mr-2" svgClasses="h-5 w-5"/>
                                    <span class="text-sm font-medium">Shared With Me</span>
                                </div>
                                <div class="p-2 flex items-center hover:text-primary cursor-pointer base-item"
                                     @mousedown.stop="selectBaseItem(4)"
                                     :class="baseItem === 4 ? 'base-item-active text-primary' : ''">
                                    <feather-icon icon="StarIcon" class="mr-2" svgClasses="h-5 w-5"/>
                                    <span class="text-sm font-medium">Starred</span>
                                </div>
                                <div class="p-2 flex items-center hover:text-primary cursor-pointer base-item"
                                     @mousedown.stop="selectBaseItem(5)"
                                     :class="baseItem === 5 ? 'base-item-active text-primary' : ''">
                                    <feather-icon icon="Trash2Icon" class="mr-2" svgClasses="h-5 w-5"/>
                                    <span class="text-sm font-medium">Trash</span>
                                </div>
                            </vs-collapse-item>
                            <vs-collapse-item icon-arrow="expand_more" v-if="baseItem === 1" open>
                                <div slot="header">
                                    <span class="text-sm font-bold" style="color: #9ca3af">Navigator</span>
                                </div>
                                <VuePerfectScrollbar ref="mainSidebarPs"
                                                     class="scroll-area--navigator p-0"
                                                     :settings="settings" :key="$vs.rtl">
                                    <v-jstree :data="treeData" collapse whole-row allow-batch @item-click="itemClick">
                                        <template slot-scope="node">
                                            <div style="min-width: 150px" class="flex items-center gap-2"
                                                 :class="(nodeSelected && (node.model.id === nodeSelected.id)) ? 'node-tree-document-selected' : 'node-tree-document-no-selected'">
                                                <i role="presentation" class="tree-icon tree-themeicon"></i>
                                                <div>
                                                    <span
                                                        :class="node.model.level === 0 ? 'font-bold' : ''">{{
                                                            node.model.text
                                                        }}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </v-jstree>
                                </VuePerfectScrollbar>
                            </vs-collapse-item>
                        </vs-collapse>
                    </div>
                </div>
            </div>
            <div class="vx-col xl:w-5/6 lg:w-3/4 sm:w-2/3 w-1/2 right-col">
                <div class="vx-row function-folder">
                    <div class="vx-col w-full flex justify-between items-center">
                        <div class="relative flex items-center text-left">
                            <svg v-if="isCheckBack" @click="goBack" xmlns="http://www.w3.org/2000/svg" width="17px"
                                 height="17px"
                                 viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                 stroke-linejoin="round"
                                 class="mr-2 -ml-1 cursor-pointer align-middle transition-all duration-200 lg:-mt-0.5 shrink-0 feather feather-chevron-left translate-x-0 opacity-100">
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                            <span
                                class="text-md font-medium">{{
                                    baseItem === 1 ? (folderHere.name ? folderHere.name : 'All Files') : baseItem === 2 ? 'Recent Upload' : baseItem === 3 ? 'Shared With Me' : baseItem === 4 ? 'Starred' : 'Trash'
                                }}</span>
                        </div>
                        <div class="flex items-center justify-end">
                            <vx-tooltip class="position-icon mr-6" :text="$t('document.createFolder')" position="top">
                                <feather-icon icon="FolderPlusIcon" svgClasses="h-6 w-6"
                                              @click="openPopupCreateFolder"/>
                            </vx-tooltip>
                            <vx-tooltip class="position-icon mr-20" :text="$t('document.uploadFile')" position="top">
                                <feather-icon icon="UploadCloudIcon" svgClasses="h-6 w-6"
                                              @click="openUploadFile"/>
                            </vx-tooltip>
                            <vs-input icon="search" class="w-1/3" v-model="folderNameSearch"
                                      placeholder="Tìm kiếm theo tên ..." @keyup.enter="loadCallFolder">
                            </vs-input>
                            <!--                            <vx-tooltip class="position-icon ml-20 mr-6" :text="$t('document.viewList')" position="top">-->
                            <!--                                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">-->
                            <!--                                    <feather-icon icon="BellIcon" svgClasses="h-6 w-6" :badge="unreadNotificationsNum"/>-->

                            <!--                                    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">-->

                            <!--                                        <div class="notification-top text-center p-5 bg-primary text-white">-->
                            <!--                                            <h3 class="text-white">{{ unreadNotificationsNum }}-->
                            <!--                                                {{ $t('notification.unreadNotice') }}</h3>-->
                            <!--                                        </div>-->
                            <!--                                        <div class="">-->
                            <!--                                            <div></div>-->
                            <!--                                        </div>-->
                            <!--                                    </vs-dropdown-menu>-->
                            <!--                                </vs-dropdown>-->
                            <!--                            </vx-tooltip>-->
                            <vx-tooltip class="position-icon ml-20 mr-6" :text="$t('document.viewList')" position="top">
                                <feather-icon icon="ListIcon" :class="isList ? 'text-primary' : ''"
                                              svgClasses="h-6 w-6" @click="changeView(true)"/>
                            </vx-tooltip>
                            <vx-tooltip class="position-icon mr-10" :text="$t('document.viewGrid')" position="top">
                                <feather-icon icon="GridIcon" :class="isList ? '' : 'text-primary'"
                                              svgClasses="h-6 w-6" @click="changeView(false)"/>
                            </vx-tooltip>
                            <vx-tooltip class="position-icon mr-2" :text="$t('document.fileDetails')" position="top">
                                <feather-icon icon="AlertCircleIcon" :class="isInfo ? 'text-primary' : ''"
                                              svgClasses="h-6 w-6" @mousedown.stop="showDetailsItem"/>
                            </vx-tooltip>
                        </div>
                    </div>
                </div>
                <div class="vx-row list-folder">
                    <div class="vx-col py-2" :class="isInfo ? 'w-3/4' : 'w-full'">
                        <VuePerfectScrollbar :settings="settings" :key="$vs.rtl" class="vx-row scroll-view-folder"
                                             @ps-scroll-y="scrollHandle">
                            <div class="vx-col"
                                 :class="isList ? 'w-full py-2 px-4' : 'lg:w-1/6 md:w-1/4 sm:w-1/3 w-1/2 py-4'"
                                 v-for="(item, ind) in dataFolder" :key="ind">
                                <div class="w-full cursor-pointer px-2" v-if="isList">
                                    <div class="item-list flex items-center hover:text-primary"
                                         :class="indexSelected === ind ? 'text-primary selectItem' : ''"
                                         @mousedown.stop="clickMouseItem($event, item, ind)"
                                         @dblclick="openItem($event, item, ind)">
                                        <svg width="53px" height="53px" viewBox="0 0 512 512" xml:space="preserve"
                                             xmlns="http://www.w3.org/2000/svg" v-if="item.type === 'folder'"
                                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <path
                                d="M463.518,94.909H193.885v-10.37c0-22.908-18.574-41.482-41.482-41.482H48.699  c-22.908,0-41.482,18.574-41.482,41.482v51.852v72.593v217.78c0,22.907,18.574,41.482,41.482,41.482h414.819  c22.908,0,41.482-18.575,41.482-41.482V136.391C505,113.483,486.426,94.909,463.518,94.909z M27.958,84.539  c0-11.435,9.308-20.741,20.741-20.741h103.705c11.433,0,20.741,9.306,20.741,20.741v10.37v20.741h20.741h269.633  c11.433,0,20.741,9.306,20.741,20.741v20.741H27.958v-20.741V84.539z M463.518,447.506H48.699c-11.433,0-20.741-9.307-20.741-20.741  v-217.78v-31.111h456.301v248.892C484.259,438.198,474.952,447.506,463.518,447.506z"
                                fill="#fbc02d"/>
                        </svg>

                                        <div style="width: 53px; height: 53px" v-if="item.type === 'image'"
                                             :id="'image-' + ind" class="vs-con-loading__container">
                                            <img :src="'https://file2.inviv.vn/' + item.url" alt=""
                                                 @load="onloadImage(`image-${ind}`)">
                                        </div>
                                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 64 64" data-testid="Icon"
                                             height="53px" width="53px" v-if="item.type === 'audio'">
                                            <g>
                                                <path
                                                    d="M 21.65625 4 C 20.320313 4 19.0625 4.519531 18.121094 5.464844 L 9.464844 14.121094 C 8.519531 15.066406 8 16.320313 8 17.65625 L 8 57 C 8 58.652344 9.347656 60 11 60 L 51 60 C 52.652344 60 54 58.652344 54 57 L 54 7 C 54 5.347656 52.652344 4 51 4 Z M 22 6 L 51 6 C 51.550781 6 52 6.449219 52 7 L 52 57 C 52 57.550781 51.550781 58 51 58 L 11 58 C 10.449219 58 10 57.550781 10 57 L 10 18 L 19 18 C 20.652344 18 22 16.652344 22 15 Z M 20 6.5 L 20 15 C 20 15.550781 19.550781 16 19 16 L 10.5 16 C 10.609375 15.835938 10.734375 15.679688 10.878906 15.535156 L 19.535156 6.878906 C 19.679688 6.734375 19.835938 6.609375 20 6.5 Z M 42.78125 18.023438 L 24.78125 22.023438 C 24.328125 22.125 24 22.53125 24 23 L 24 37 C 20.691406 37 18 39.242188 18 42 C 18 44.757813 20.691406 47 24 47 C 27.308594 47 30 44.757813 30 42 L 30 29.910156 L 38 28.136719 L 38 33 C 34.691406 33 32 35.242188 32 38 C 32 40.757813 34.691406 43 38 43 C 41.308594 43 44 40.757813 44 38 L 44 19 C 44 18.695313 43.863281 18.410156 43.625 18.21875 C 43.390625 18.03125 43.082031 17.960938 42.78125 18.023438 Z M 42 20.246094 L 42 38 C 42 39.652344 40.207031 41 38 41 C 35.792969 41 34 39.652344 34 38 C 34 36.347656 35.792969 35 38 35 C 38.28125 35 38.5625 35.023438 38.839844 35.066406 C 39.128906 35.117188 39.421875 35.03125 39.648438 34.84375 C 39.871094 34.652344 40 34.375 40 34.078125 L 40 26.890625 C 40 26.585938 39.863281 26.300781 39.625 26.109375 C 39.390625 25.921875 39.078125 25.847656 38.78125 25.910156 L 28.78125 28.136719 C 28.328125 28.238281 28 28.644531 28 29.109375 L 28 42 C 28 43.652344 26.207031 45 24 45 C 21.792969 45 20 43.652344 20 42 C 20 40.347656 21.792969 39 24 39 C 24.28125 39 24.5625 39.023438 24.839844 39.066406 C 25.128906 39.117188 25.425781 39.03125 25.648438 38.84375 C 25.871094 38.652344 26 38.375 26 38.078125 L 26 23.800781 Z M 13 52 C 12.449219 52 12 52.445313 12 53 L 12 55 C 12 55.554688 12.449219 56 13 56 C 13.550781 56 14 55.554688 14 55 L 14 53 C 14 52.445313 13.550781 52 13 52 Z M 18 52 C 17.449219 52 17 52.445313 17 53 L 17 55 C 17 55.554688 17.449219 56 18 56 C 18.550781 56 19 55.554688 19 55 L 19 53 C 19 52.445313 18.550781 52 18 52 Z M 23 52 C 22.449219 52 22 52.445313 22 53 L 22 55 C 22 55.554688 22.449219 56 23 56 C 23.550781 56 24 55.554688 24 55 L 24 53 C 24 52.445313 23.550781 52 23 52 Z M 28 52 C 27.449219 52 27 52.445313 27 53 L 27 55 C 27 55.554688 27.449219 56 28 56 C 28.550781 56 29 55.554688 29 55 L 29 53 C 29 52.445313 28.550781 52 28 52 Z M 33 52 C 32.449219 52 32 52.445313 32 53 L 32 55 C 32 55.554688 32.449219 56 33 56 C 33.550781 56 34 55.554688 34 55 L 34 53 C 34 52.445313 33.550781 52 33 52 Z M 38 52 C 37.449219 52 37 52.445313 37 53 L 37 55 C 37 55.554688 37.449219 56 38 56 C 38.550781 56 39 55.554688 39 55 L 39 53 C 39 52.445313 38.550781 52 38 52 Z M 43 52 C 42.449219 52 42 52.445313 42 53 L 42 55 C 42 55.554688 42.449219 56 43 56 C 43.550781 56 44 55.554688 44 55 L 44 53 C 44 52.445313 43.550781 52 43 52 Z M 48 52 C 47.449219 52 47 52.445313 47 53 L 47 55 C 47 55.554688 47.449219 56 48 56 C 48.550781 56 49 55.554688 49 55 L 49 53 C 49 52.445313 48.550781 52 48 52 Z "
                                                    fill="#ff9800"/>
                                            </g>
                                        </svg>
                                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 64 64" data-testid="Icon"
                                             height="53px" width="53px" v-if="item.type === 'video'">
                                            <g>
                                                <path
                                                    d="M 23.65625 4 C 22.320313 4 21.0625 4.519531 20.121094 5.464844 L 11.464844 14.121094 C 10.519531 15.066406 10 16.320313 10 17.65625 L 10 57 C 10 58.652344 11.347656 60 13 60 L 53 60 C 54.652344 60 56 58.652344 56 57 L 56 7 C 56 5.347656 54.652344 4 53 4 Z M 24 6 L 53 6 C 53.550781 6 54 6.449219 54 7 L 54 57 C 54 57.550781 53.550781 58 53 58 L 13 58 C 12.449219 58 12 57.550781 12 57 L 12 18 L 21 18 C 22.652344 18 24 16.652344 24 15 Z M 22 6.5 L 22 15 C 22 15.550781 21.550781 16 21 16 L 12.5 16 C 12.613281 15.835938 12.738281 15.675781 12.878906 15.535156 L 21.535156 6.878906 C 21.679688 6.734375 21.835938 6.609375 22 6.5 Z M 28.023438 21.816406 C 27.671875 21.808594 27.316406 21.890625 26.996094 22.0625 C 26.355469 22.417969 25.964844 23.085938 25.964844 23.816406 L 25.964844 42.183594 C 25.964844 42.910156 26.355469 43.582031 26.996094 43.933594 C 27.296875 44.097656 27.632813 44.183594 27.964844 44.183594 C 28.335938 44.183594 28.707031 44.078125 29.03125 43.871094 L 43.53125 34.6875 C 44.113281 34.320313 44.464844 33.6875 44.464844 33 C 44.464844 32.308594 44.113281 31.679688 43.53125 31.3125 L 29.03125 22.125 C 28.722656 21.933594 28.375 21.828125 28.023438 21.816406 Z M 27.964844 23.816406 L 42.464844 33 L 27.964844 42.1875 Z M 15 52 C 14.449219 52 14 52.449219 14 53 L 14 55 C 14 55.550781 14.449219 56 15 56 C 15.550781 56 16 55.550781 16 55 L 16 53 C 16 52.449219 15.550781 52 15 52 Z M 20 52 C 19.449219 52 19 52.449219 19 53 L 19 55 C 19 55.550781 19.449219 56 20 56 C 20.550781 56 21 55.550781 21 55 L 21 53 C 21 52.449219 20.550781 52 20 52 Z M 25 52 C 24.449219 52 24 52.449219 24 53 L 24 55 C 24 55.550781 24.449219 56 25 56 C 25.550781 56 26 55.550781 26 55 L 26 53 C 26 52.449219 25.550781 52 25 52 Z M 30 52 C 29.449219 52 29 52.449219 29 53 L 29 55 C 29 55.550781 29.449219 56 30 56 C 30.550781 56 31 55.550781 31 55 L 31 53 C 31 52.449219 30.550781 52 30 52 Z M 35 52 C 34.449219 52 34 52.449219 34 53 L 34 55 C 34 55.550781 34.449219 56 35 56 C 35.550781 56 36 55.550781 36 55 L 36 53 C 36 52.449219 35.550781 52 35 52 Z M 40 52 C 39.449219 52 39 52.449219 39 53 L 39 55 C 39 55.550781 39.449219 56 40 56 C 40.550781 56 41 55.550781 41 55 L 41 53 C 41 52.449219 40.550781 52 40 52 Z M 45 52 C 44.449219 52 44 52.449219 44 53 L 44 55 C 44 55.550781 44.449219 56 45 56 C 45.550781 56 46 55.550781 46 55 L 46 53 C 46 52.449219 45.550781 52 45 52 Z M 50 52 C 49.449219 52 49 52.449219 49 53 L 49 55 C 49 55.550781 49.449219 56 50 56 C 50.550781 56 51 55.550781 51 55 L 51 53 C 51 52.449219 50.550781 52 50 52 Z "
                                                    fill="#f44336"/>
                                            </g>
                                        </svg>
                                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 64 64" data-testid="Icon"
                                             height="53px" width="53px" v-if="item.type === 'spreadsheet'">
                                            <g>
                                                <path
                                                    d="M 35.136719 2.386719 C 34.917969 2.378906 34.699219 2.390625 34.480469 2.429688 L 5.304688 7.578125 C 3.390625 7.917969 2 9.574219 2 11.515625 L 2 50.484375 C 2 52.429688 3.390625 54.085938 5.304688 54.421875 L 34.480469 59.570313 C 34.652344 59.601563 34.828125 59.613281 35 59.613281 C 35.703125 59.613281 36.382813 59.371094 36.925781 58.914063 C 37.609375 58.34375 38 57.503906 38 56.613281 L 38 52 L 57 52 C 58.652344 52 60 50.652344 60 49 L 60 13 C 60 11.347656 58.652344 10 57 10 L 38 10 L 38 5.382813 C 38 4.496094 37.609375 3.65625 36.925781 3.085938 C 36.417969 2.65625 35.789063 2.414063 35.136719 2.386719 Z M 35.105469 4.390625 C 35.359375 4.414063 35.542969 4.535156 35.640625 4.617188 C 35.777344 4.730469 36 4.980469 36 5.382813 L 36 56.613281 C 36 57.019531 35.777344 57.269531 35.640625 57.382813 C 35.507813 57.496094 35.226563 57.671875 34.828125 57.601563 L 5.652344 52.453125 C 4.695313 52.285156 4 51.457031 4 50.484375 L 4 11.515625 C 4 10.542969 4.695313 9.714844 5.652344 9.546875 L 34.824219 4.398438 C 34.925781 4.382813 35.019531 4.378906 35.105469 4.390625 Z M 38 12 L 57 12 C 57.550781 12 58 12.449219 58 13 L 58 49 C 58 49.550781 57.550781 50 57 50 L 38 50 L 38 44 L 41 44 C 41.550781 44 42 43.554688 42 43 C 42 42.445313 41.550781 42 41 42 L 38 42 L 38 38 L 41 38 C 41.550781 38 42 37.554688 42 37 C 42 36.445313 41.550781 36 41 36 L 38 36 L 38 32 L 41 32 C 41.550781 32 42 31.554688 42 31 C 42 30.445313 41.550781 30 41 30 L 38 30 L 38 26 L 41 26 C 41.550781 26 42 25.554688 42 25 C 42 24.445313 41.550781 24 41 24 L 38 24 L 38 20 L 41 20 C 41.550781 20 42 19.554688 42 19 C 42 18.445313 41.550781 18 41 18 L 38 18 Z M 45 18 C 44.449219 18 44 18.445313 44 19 C 44 19.554688 44.449219 20 45 20 L 51 20 C 51.550781 20 52 19.554688 52 19 C 52 18.445313 51.550781 18 51 18 Z M 12.824219 20.015625 C 12.695313 20.039063 12.570313 20.085938 12.453125 20.160156 C 11.992188 20.460938 11.859375 21.082031 12.160156 21.546875 L 18.308594 31 L 12.160156 40.453125 C 11.859375 40.917969 11.992188 41.539063 12.453125 41.839844 C 12.625 41.949219 12.8125 42 13 42 C 13.324219 42 13.648438 41.839844 13.839844 41.546875 L 19.5 32.835938 L 25.160156 41.546875 C 25.351563 41.839844 25.675781 42 26 42 C 26.1875 42 26.375 41.949219 26.546875 41.839844 C 27.007813 41.539063 27.140625 40.917969 26.839844 40.453125 L 20.691406 31 L 26.839844 21.546875 C 27.140625 21.082031 27.007813 20.460938 26.546875 20.160156 C 26.082031 19.859375 25.460938 19.992188 25.160156 20.453125 L 19.5 29.164063 L 13.839844 20.453125 C 13.613281 20.105469 13.207031 19.945313 12.824219 20.015625 Z M 45 24 C 44.449219 24 44 24.445313 44 25 C 44 25.554688 44.449219 26 45 26 L 51 26 C 51.550781 26 52 25.554688 52 25 C 52 24.445313 51.550781 24 51 24 Z M 45 30 C 44.449219 30 44 30.445313 44 31 C 44 31.554688 44.449219 32 45 32 L 51 32 C 51.550781 32 52 31.554688 52 31 C 52 30.445313 51.550781 30 51 30 Z M 45 36 C 44.449219 36 44 36.445313 44 37 C 44 37.554688 44.449219 38 45 38 L 51 38 C 51.550781 38 52 37.554688 52 37 C 52 36.445313 51.550781 36 51 36 Z M 45 42 C 44.449219 42 44 42.445313 44 43 C 44 43.554688 44.449219 44 45 44 L 51 44 C 51.550781 44 52 43.554688 52 43 C 52 42.445313 51.550781 42 51 42 Z "
                                                    fill="#27764B"></path>
                                            </g>
                                        </svg>
                                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 64 64" data-testid="Icon"
                                             height="53px" width="53px" v-if="item.type === 'pdf'">
                                            <g>
                                                <path
                                                    d="M 17.65625 4 C 16.320313 4 15.066406 4.519531 14.121094 5.464844 L 5.464844 14.121094 C 4.519531 15.066406 4 16.320313 4 17.65625 L 4 57 C 4 58.652344 5.347656 60 7 60 L 47 60 C 48.652344 60 50 58.652344 50 57 L 50 46 L 58 46 C 59.101563 46 60 45.101563 60 44 L 60 24 C 60 22.898438 59.101563 22 58 22 L 50 22 L 50 7 C 50 5.347656 48.652344 4 47 4 Z M 18 6 L 47 6 C 47.550781 6 48 6.449219 48 7 L 48 22 L 16 22 C 14.898438 22 14 22.898438 14 24 L 14 44 C 14 45.101563 14.898438 46 16 46 L 48 46 L 48 57 C 48 57.550781 47.550781 58 47 58 L 7 58 C 6.449219 58 6 57.550781 6 57 L 6 18 L 15 18 C 16.652344 18 18 16.652344 18 15 Z M 16 6.5 L 16 15 C 16 15.550781 15.550781 16 15 16 L 6.5 16 C 6.609375 15.835938 6.734375 15.679688 6.878906 15.535156 L 15.535156 6.878906 C 15.679688 6.734375 15.835938 6.609375 16 6.5 Z M 16 24 L 58 24 L 58 44 L 16 44 Z M 25 28 C 24.445313 28 24 28.449219 24 29 L 24 39 C 24 39.550781 24.445313 40 25 40 C 25.554688 40 26 39.550781 26 39 L 26 36 L 29 36 C 30.652344 36 32 34.652344 32 33 L 32 31 C 32 29.347656 30.652344 28 29 28 Z M 35 28 C 34.445313 28 34 28.449219 34 29 L 34 39 C 34 39.550781 34.445313 40 35 40 L 38 40 C 40.207031 40 42 38.207031 42 36 L 42 32 C 42 29.792969 40.207031 28 38 28 Z M 45 28 C 44.445313 28 44 28.449219 44 29 L 44 39 C 44 39.550781 44.445313 40 45 40 C 45.554688 40 46 39.550781 46 39 L 46 36 L 49 36 C 49.554688 36 50 35.550781 50 35 C 50 34.449219 49.554688 34 49 34 L 46 34 L 46 30 L 50 30 C 50.554688 30 51 29.550781 51 29 C 51 28.449219 50.554688 28 50 28 Z M 26 30 L 29 30 C 29.550781 30 30 30.449219 30 31 L 30 33 C 30 33.550781 29.550781 34 29 34 L 26 34 Z M 36 30 L 38 30 C 39.101563 30 40 30.898438 40 32 L 40 36 C 40 37.101563 39.101563 38 38 38 L 36 38 Z M 9 52 C 8.445313 52 8 52.449219 8 53 L 8 55 C 8 55.550781 8.445313 56 9 56 C 9.554688 56 10 55.550781 10 55 L 10 53 C 10 52.449219 9.554688 52 9 52 Z M 14 52 C 13.445313 52 13 52.449219 13 53 L 13 55 C 13 55.550781 13.445313 56 14 56 C 14.554688 56 15 55.550781 15 55 L 15 53 C 15 52.449219 14.554688 52 14 52 Z M 19 52 C 18.445313 52 18 52.449219 18 53 L 18 55 C 18 55.550781 18.445313 56 19 56 C 19.554688 56 20 55.550781 20 55 L 20 53 C 20 52.449219 19.554688 52 19 52 Z M 24 52 C 23.445313 52 23 52.449219 23 53 L 23 55 C 23 55.550781 23.445313 56 24 56 C 24.554688 56 25 55.550781 25 55 L 25 53 C 25 52.449219 24.554688 52 24 52 Z M 29 52 C 28.445313 52 28 52.449219 28 53 L 28 55 C 28 55.550781 28.445313 56 29 56 C 29.554688 56 30 55.550781 30 55 L 30 53 C 30 52.449219 29.554688 52 29 52 Z M 34 52 C 33.445313 52 33 52.449219 33 53 L 33 55 C 33 55.550781 33.445313 56 34 56 C 34.554688 56 35 55.550781 35 55 L 35 53 C 35 52.449219 34.554688 52 34 52 Z M 39 52 C 38.445313 52 38 52.449219 38 53 L 38 55 C 38 55.550781 38.445313 56 39 56 C 39.554688 56 40 55.550781 40 55 L 40 53 C 40 52.449219 39.554688 52 39 52 Z M 44 52 C 43.445313 52 43 52.449219 43 53 L 43 55 C 43 55.550781 43.445313 56 44 56 C 44.554688 56 45 55.550781 45 55 L 45 53 C 45 52.449219 44.554688 52 44 52 Z "
                                                    fill="#B51308"></path>
                                            </g>
                                        </svg>
                                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 64 64" data-testid="Icon"
                                             height="53px" width="53px" v-if="item.type === 'word'">
                                            <g>
                                                <path
                                                    d="M 21.65625 4 C 20.320313 4 19.0625 4.519531 18.121094 5.464844 L 9.464844 14.121094 C 8.519531 15.066406 8 16.320313 8 17.65625 L 8 57 C 8 58.652344 9.347656 60 11 60 L 51 60 C 52.652344 60 54 58.652344 54 57 L 54 7 C 54 5.347656 52.652344 4 51 4 Z M 22 6 L 51 6 C 51.550781 6 52 6.449219 52 7 L 52 57 C 52 57.550781 51.550781 58 51 58 L 11 58 C 10.449219 58 10 57.550781 10 57 L 10 18 L 19 18 C 20.652344 18 22 16.652344 22 15 Z M 20 6.5 L 20 15 C 20 15.550781 19.550781 16 19 16 L 10.5 16 C 10.613281 15.832031 10.738281 15.675781 10.878906 15.535156 L 19.535156 6.878906 C 19.679688 6.734375 19.835938 6.609375 20 6.5 Z M 21.140625 23.011719 C 21.015625 22.992188 20.878906 22.996094 20.746094 23.03125 C 20.210938 23.175781 19.894531 23.722656 20.03125 24.253906 L 25.03125 43.253906 C 25.148438 43.691406 25.539063 43.996094 25.984375 44 L 26 44 C 26.441406 44 26.832031 43.710938 26.957031 43.28125 L 31 29.546875 L 35.042969 43.28125 C 35.167969 43.707031 35.558594 44 36 44 L 36.015625 44 C 36.460938 43.992188 36.851563 43.6875 36.96875 43.253906 L 41.96875 24.253906 C 42.105469 23.722656 41.789063 23.175781 41.253906 23.03125 C 40.71875 22.890625 40.171875 23.210938 40.03125 23.746094 L 35.945313 39.273438 L 31.957031 25.71875 C 31.832031 25.292969 31.445313 25 31 25 C 30.554688 25 30.167969 25.292969 30.042969 25.71875 L 26.054688 39.277344 L 21.96875 23.746094 C 21.863281 23.347656 21.527344 23.066406 21.140625 23.011719 Z M 13 52 C 12.449219 52 12 52.445313 12 53 L 12 55 C 12 55.554688 12.449219 56 13 56 C 13.550781 56 14 55.554688 14 55 L 14 53 C 14 52.445313 13.550781 52 13 52 Z M 18 52 C 17.449219 52 17 52.445313 17 53 L 17 55 C 17 55.554688 17.449219 56 18 56 C 18.550781 56 19 55.554688 19 55 L 19 53 C 19 52.445313 18.550781 52 18 52 Z M 23 52 C 22.449219 52 22 52.445313 22 53 L 22 55 C 22 55.554688 22.449219 56 23 56 C 23.550781 56 24 55.554688 24 55 L 24 53 C 24 52.445313 23.550781 52 23 52 Z M 28 52 C 27.449219 52 27 52.445313 27 53 L 27 55 C 27 55.554688 27.449219 56 28 56 C 28.550781 56 29 55.554688 29 55 L 29 53 C 29 52.445313 28.550781 52 28 52 Z M 33 52 C 32.449219 52 32 52.445313 32 53 L 32 55 C 32 55.554688 32.449219 56 33 56 C 33.550781 56 34 55.554688 34 55 L 34 53 C 34 52.445313 33.550781 52 33 52 Z M 38 52 C 37.449219 52 37 52.445313 37 53 L 37 55 C 37 55.554688 37.449219 56 38 56 C 38.550781 56 39 55.554688 39 55 L 39 53 C 39 52.445313 38.550781 52 38 52 Z M 43 52 C 42.449219 52 42 52.445313 42 53 L 42 55 C 42 55.554688 42.449219 56 43 56 C 43.550781 56 44 55.554688 44 55 L 44 53 C 44 52.445313 43.550781 52 43 52 Z M 48 52 C 47.449219 52 47 52.445313 47 53 L 47 55 C 47 55.554688 47.449219 56 48 56 C 48.550781 56 49 55.554688 49 55 L 49 53 C 49 52.445313 48.550781 52 48 52 Z "
                                                    fill="#1D59B9"></path>
                                            </g>
                                        </svg>
                                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 64 64" data-testid="Icon"
                                             height="53px" width="53px" v-if="item.type === 'powerPoint'">
                                            <g>
                                                <path
                                                    d="M 35.136719 2.386719 C 34.917969 2.378906 34.699219 2.390625 34.480469 2.429688 L 5.304688 7.578125 C 3.390625 7.917969 2 9.574219 2 11.515625 L 2 50.484375 C 2 52.429688 3.390625 54.085938 5.304688 54.421875 L 34.480469 59.570313 C 34.652344 59.601563 34.828125 59.613281 35 59.613281 C 35.703125 59.613281 36.382813 59.371094 36.925781 58.914063 C 37.609375 58.34375 38 57.503906 38 56.613281 L 38 52 L 57 52 C 58.652344 52 60 50.652344 60 49 L 60 13 C 60 11.347656 58.652344 10 57 10 L 38 10 L 38 5.382813 C 38 4.496094 37.609375 3.65625 36.925781 3.085938 C 36.417969 2.65625 35.789063 2.414063 35.136719 2.386719 Z M 35.105469 4.390625 C 35.359375 4.414063 35.542969 4.535156 35.640625 4.617188 C 35.777344 4.730469 36 4.980469 36 5.382813 L 36 56.613281 C 36 57.019531 35.777344 57.269531 35.640625 57.382813 C 35.507813 57.496094 35.226563 57.667969 34.828125 57.601563 L 5.652344 52.453125 C 4.695313 52.285156 4 51.457031 4 50.484375 L 4 11.515625 C 4 10.542969 4.695313 9.714844 5.652344 9.546875 L 34.824219 4.398438 C 34.925781 4.382813 35.019531 4.378906 35.105469 4.390625 Z M 38 12 L 57 12 C 57.550781 12 58 12.449219 58 13 L 58 49 C 58 49.550781 57.550781 50 57 50 L 38 50 L 38 45.949219 L 52.949219 45.949219 C 53.5 45.949219 53.949219 45.554688 53.949219 45 C 53.949219 44.445313 53.5 44 52.949219 44 L 50 44 L 50 41 C 50 40.445313 49.550781 40 49 40 L 46 40 L 46 37 C 46 36.445313 45.550781 36 45 36 L 41 36 C 40.449219 36 40 36.445313 40 37 L 40 39 L 38 39 L 38 32.46875 C 39.46875 33.449219 41.203125 34 43 34 C 47.960938 34 52 29.964844 52 25 C 52 20.035156 47.960938 16 43 16 C 41.1875 16 39.464844 16.535156 38 17.519531 Z M 42 18.078125 L 42 24.832031 C 42 25.027344 42.070313 25.203125 42.171875 25.359375 C 42.21875 25.492188 42.289063 25.617188 42.394531 25.726563 L 47.234375 30.5625 C 46.054688 31.460938 44.589844 32 43 32 C 41.113281 32 39.316406 31.230469 38 29.886719 L 38 20.105469 C 39.089844 18.992188 40.484375 18.292969 42 18.078125 Z M 44 18.078125 C 47.386719 18.566406 50 21.480469 50 25 C 50 26.546875 49.488281 27.976563 48.636719 29.136719 L 44 24.5 Z M 15 20 C 14.449219 20 14 20.445313 14 21 L 14 41 C 14 41.554688 14.449219 42 15 42 C 15.550781 42 16 41.554688 16 41 L 16 34 L 21 34 C 23.757813 34 26 31.757813 26 29 L 26 25 C 26 22.242188 23.757813 20 21 20 Z M 16 22 L 21 22 C 22.652344 22 24 23.347656 24 25 L 24 29 C 24 30.652344 22.652344 32 21 32 L 16 32 Z M 42 38 L 44 38 L 44 44 L 42 44 Z M 38 41 L 40 41 L 40 44 L 38 44 Z M 46 42 L 48 42 L 48 44 L 46 44 Z "
                                                    fill="#D14B2B"></path>
                                            </g>
                                        </svg>
                                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 64 64" data-testid="Icon"
                                             height="53px" width="53px" v-if="item.type === 'archive'">
                                            <g>
                                                <path
                                                    d="M 21.65625 4 C 20.320313 4 19.066406 4.519531 18.121094 5.464844 L 9.464844 14.121094 C 8.519531 15.066406 8 16.320313 8 17.65625 L 8 57 C 8 58.652344 9.347656 60 11 60 L 51 60 C 52.652344 60 54 58.652344 54 57 L 54 7 C 54 5.347656 52.652344 4 51 4 Z M 22 6 L 36 6 L 36 27.59375 C 35.144531 27.222656 34.210938 27 33.226563 27 L 32.773438 27 C 31.789063 27 30.859375 27.222656 30 27.59375 L 30 9 C 30 8.449219 29.554688 8 29 8 C 28.449219 8 28 8.449219 28 9 L 28 28.902344 C 27.015625 29.824219 26.277344 31.023438 25.953125 32.425781 L 24.875 37.097656 C 24.597656 38.292969 24.878906 39.53125 25.640625 40.488281 C 26.40625 41.449219 27.546875 42 28.769531 42 L 37.230469 42 C 38.457031 42 39.59375 41.449219 40.359375 40.488281 C 41.121094 39.53125 41.402344 38.292969 41.125 37.097656 L 40.046875 32.425781 C 39.726563 31.023438 38.984375 29.824219 38 28.902344 L 38 6 L 51 6 C 51.550781 6 52 6.449219 52 7 L 52 57 C 52 57.550781 51.550781 58 51 58 L 11 58 C 10.449219 58 10 57.550781 10 57 L 10 18 L 19 18 C 20.652344 18 22 16.652344 22 15 Z M 20 6.5 L 20 15 C 20 15.550781 19.550781 16 19 16 L 10.5 16 C 10.609375 15.835938 10.734375 15.679688 10.878906 15.535156 L 19.535156 6.878906 C 19.679688 6.738281 19.835938 6.609375 20 6.5 Z M 32 8 C 31.449219 8 31 8.445313 31 9 C 31 9.554688 31.449219 10 32 10 L 34 10 C 34.550781 10 35 9.554688 35 9 C 35 8.445313 34.550781 8 34 8 Z M 32 13 C 31.449219 13 31 13.445313 31 14 C 31 14.554688 31.449219 15 32 15 L 34 15 C 34.550781 15 35 14.554688 35 14 C 35 13.445313 34.550781 13 34 13 Z M 32 18 C 31.449219 18 31 18.445313 31 19 C 31 19.554688 31.449219 20 32 20 L 34 20 C 34.550781 20 35 19.554688 35 19 C 35 18.445313 34.550781 18 34 18 Z M 32 23 C 31.449219 23 31 23.445313 31 24 C 31 24.554688 31.449219 25 32 25 L 34 25 C 34.550781 25 35 24.554688 35 24 C 35 23.445313 34.550781 23 34 23 Z M 32.773438 29 L 33.226563 29 C 35.570313 29 37.574219 30.59375 38.097656 32.875 L 39.175781 37.550781 C 39.316406 38.148438 39.175781 38.765625 38.796875 39.246094 C 38.414063 39.722656 37.839844 40 37.230469 40 L 28.769531 40 C 28.160156 40 27.589844 39.722656 27.207031 39.246094 C 26.824219 38.765625 26.683594 38.148438 26.824219 37.550781 L 27.902344 32.875 C 28.429688 30.59375 30.429688 29 32.773438 29 Z M 31 34 C 30.449219 34 30 34.445313 30 35 C 30 35.554688 30.449219 36 31 36 L 35 36 C 35.550781 36 36 35.554688 36 35 C 36 34.445313 35.550781 34 35 34 Z M 13 52 C 12.449219 52 12 52.445313 12 53 C 12 53.554688 12.449219 54 13 54 L 17 54 C 17.550781 54 18 53.554688 18 53 C 18 52.445313 17.550781 52 17 52 Z M 21 52 C 20.449219 52 20 52.445313 20 53 C 20 53.554688 20.449219 54 21 54 L 49 54 C 49.550781 54 50 53.554688 50 53 C 50 52.445313 49.550781 52 49 52 Z "
                                                    fill="#37404D"></path>
                                            </g>
                                        </svg>
                                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 64 64" data-testid="Icon"
                                             height="53px" width="53px" v-if="item.type === 'file'">
                                            <g>
                                                <path
                                                    d="M 23.65625 4 C 22.320313 4 21.066406 4.519531 20.121094 5.464844 L 11.464844 14.121094 C 10.519531 15.066406 10 16.320313 10 17.65625 L 10 57 C 10 58.652344 11.347656 60 13 60 L 53 60 C 54.652344 60 56 58.652344 56 57 L 56 7 C 56 5.347656 54.652344 4 53 4 Z M 24 6 L 53 6 C 53.550781 6 54 6.449219 54 7 L 54 57 C 54 57.550781 53.550781 58 53 58 L 13 58 C 12.449219 58 12 57.550781 12 57 L 12 18 L 21 18 C 22.652344 18 24 16.652344 24 15 Z M 22 6.5 L 22 15 C 22 15.550781 21.550781 16 21 16 L 12.5 16 C 12.605469 15.835938 12.734375 15.679688 12.878906 15.535156 L 21.535156 6.878906 C 21.679688 6.738281 21.835938 6.613281 22 6.5 Z M 21 22 C 20.449219 22 20 22.449219 20 23 C 20 23.550781 20.449219 24 21 24 L 37 24 C 37.550781 24 38 23.550781 38 23 C 38 22.449219 37.550781 22 37 22 Z M 41 22 C 40.449219 22 40 22.449219 40 23 C 40 23.550781 40.449219 24 41 24 L 45 24 C 45.550781 24 46 23.550781 46 23 C 46 22.449219 45.550781 22 45 22 Z M 21 26 C 20.449219 26 20 26.449219 20 27 C 20 27.550781 20.449219 28 21 28 L 41 28 C 41.550781 28 42 27.550781 42 27 C 42 26.449219 41.550781 26 41 26 Z M 21 32 C 20.449219 32 20 32.449219 20 33 C 20 33.550781 20.449219 34 21 34 L 43 34 C 43.550781 34 44 33.550781 44 33 C 44 32.449219 43.550781 32 43 32 Z M 21 36 C 20.449219 36 20 36.449219 20 37 C 20 37.550781 20.449219 38 21 38 L 33 38 C 33.550781 38 34 37.550781 34 37 C 34 36.449219 33.550781 36 33 36 Z M 15 50 C 14.449219 50 14 50.449219 14 51 L 14 53 C 14 53.550781 14.449219 54 15 54 C 15.550781 54 16 53.550781 16 53 L 16 51 C 16 50.449219 15.550781 50 15 50 Z M 20 50 C 19.449219 50 19 50.449219 19 51 L 19 53 C 19 53.550781 19.449219 54 20 54 C 20.550781 54 21 53.550781 21 53 L 21 51 C 21 50.449219 20.550781 50 20 50 Z M 25 50 C 24.449219 50 24 50.449219 24 51 L 24 53 C 24 53.550781 24.449219 54 25 54 C 25.550781 54 26 53.550781 26 53 L 26 51 C 26 50.449219 25.550781 50 25 50 Z M 30 50 C 29.449219 50 29 50.449219 29 51 L 29 53 C 29 53.550781 29.449219 54 30 54 C 30.550781 54 31 53.550781 31 53 L 31 51 C 31 50.449219 30.550781 50 30 50 Z M 35 50 C 34.449219 50 34 50.449219 34 51 L 34 53 C 34 53.550781 34.449219 54 35 54 C 35.550781 54 36 53.550781 36 53 L 36 51 C 36 50.449219 35.550781 50 35 50 Z M 40 50 C 39.449219 50 39 50.449219 39 51 L 39 53 C 39 53.550781 39.449219 54 40 54 C 40.550781 54 41 53.550781 41 53 L 41 51 C 41 50.449219 40.550781 50 40 50 Z M 45 50 C 44.449219 50 44 50.449219 44 51 L 44 53 C 44 53.550781 44.449219 54 45 54 C 45.550781 54 46 53.550781 46 53 L 46 51 C 46 50.449219 45.550781 50 45 50 Z M 50 50 C 49.449219 50 49 50.449219 49 51 L 49 53 C 49 53.550781 49.449219 54 50 54 C 50.550781 54 51 53.550781 51 53 L 51 51 C 51 50.449219 50.550781 50 50 50 Z"
                                                    fill="#37404D"></path>
                                            </g>
                                        </svg>
                                        <div class="vx-row w-full">
                                            <div class="vx-col w-1/2 pl-6">
                                                <p class="text-md font-bold">{{ item.name }}</p>
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <p>Date modified: {{ item.modifiedDateStr }}</p>
                                                <p>Size: {{
                                                        (item.file_size < 1024) ? '1 KB' : ((1048576 > item.file_size) && (item.file_size >= 1024)) ? ((item.file_size / 1024).toFixed(2) + ' KB') : ((1073741824 > item.file_size) && (item.file_size >= 1048576)) ? ((item.file_size / 1048576).toFixed(2) + ' MB') : (item.file_size >= 1073741824) ? ((item.file_size / 1073741824).toFixed(2) + ' GB') : '...'
                                                    }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else
                                     class="item-folder flex justify-center items-center cursor-pointer hover:text-primary p-1"
                                     :class="indexSelected === ind ? 'text-primary selectItem' : ''"
                                     @mousedown.stop="clickMouseItem($event, item, ind)"
                                     @dblclick="openItem($event, item, ind)">
                                    <div>
                                        <div class="flex justify-center">
                                            <svg width="80px" height="80px" viewBox="0 0 512 512" xml:space="preserve"
                                                 xmlns="http://www.w3.org/2000/svg" v-if="item.type === 'folder'"
                                                 xmlns:xlink="http://www.w3.org/1999/xlink">
                            <path
                                d="M463.518,94.909H193.885v-10.37c0-22.908-18.574-41.482-41.482-41.482H48.699  c-22.908,0-41.482,18.574-41.482,41.482v51.852v72.593v217.78c0,22.907,18.574,41.482,41.482,41.482h414.819  c22.908,0,41.482-18.575,41.482-41.482V136.391C505,113.483,486.426,94.909,463.518,94.909z M27.958,84.539  c0-11.435,9.308-20.741,20.741-20.741h103.705c11.433,0,20.741,9.306,20.741,20.741v10.37v20.741h20.741h269.633  c11.433,0,20.741,9.306,20.741,20.741v20.741H27.958v-20.741V84.539z M463.518,447.506H48.699c-11.433,0-20.741-9.307-20.741-20.741  v-217.78v-31.111h456.301v248.892C484.259,438.198,474.952,447.506,463.518,447.506z"
                                fill="#fbc02d"/>
                        </svg>
                                            <div style="width: 80px; height: 80px" v-if="item.type === 'image'"
                                                 :id="'image-' + ind" class="vs-con-loading__container">
                                                <img :src="'https://file2.inviv.vn/' + item.url" alt=""
                                                     @load="onloadImage(`image-${ind}`)">
                                            </div>
                                            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 64 64" data-testid="Icon"
                                                 height="80px" width="80px" v-if="item.type === 'audio'">
                                                <g>
                                                    <path
                                                        d="M 21.65625 4 C 20.320313 4 19.0625 4.519531 18.121094 5.464844 L 9.464844 14.121094 C 8.519531 15.066406 8 16.320313 8 17.65625 L 8 57 C 8 58.652344 9.347656 60 11 60 L 51 60 C 52.652344 60 54 58.652344 54 57 L 54 7 C 54 5.347656 52.652344 4 51 4 Z M 22 6 L 51 6 C 51.550781 6 52 6.449219 52 7 L 52 57 C 52 57.550781 51.550781 58 51 58 L 11 58 C 10.449219 58 10 57.550781 10 57 L 10 18 L 19 18 C 20.652344 18 22 16.652344 22 15 Z M 20 6.5 L 20 15 C 20 15.550781 19.550781 16 19 16 L 10.5 16 C 10.609375 15.835938 10.734375 15.679688 10.878906 15.535156 L 19.535156 6.878906 C 19.679688 6.734375 19.835938 6.609375 20 6.5 Z M 42.78125 18.023438 L 24.78125 22.023438 C 24.328125 22.125 24 22.53125 24 23 L 24 37 C 20.691406 37 18 39.242188 18 42 C 18 44.757813 20.691406 47 24 47 C 27.308594 47 30 44.757813 30 42 L 30 29.910156 L 38 28.136719 L 38 33 C 34.691406 33 32 35.242188 32 38 C 32 40.757813 34.691406 43 38 43 C 41.308594 43 44 40.757813 44 38 L 44 19 C 44 18.695313 43.863281 18.410156 43.625 18.21875 C 43.390625 18.03125 43.082031 17.960938 42.78125 18.023438 Z M 42 20.246094 L 42 38 C 42 39.652344 40.207031 41 38 41 C 35.792969 41 34 39.652344 34 38 C 34 36.347656 35.792969 35 38 35 C 38.28125 35 38.5625 35.023438 38.839844 35.066406 C 39.128906 35.117188 39.421875 35.03125 39.648438 34.84375 C 39.871094 34.652344 40 34.375 40 34.078125 L 40 26.890625 C 40 26.585938 39.863281 26.300781 39.625 26.109375 C 39.390625 25.921875 39.078125 25.847656 38.78125 25.910156 L 28.78125 28.136719 C 28.328125 28.238281 28 28.644531 28 29.109375 L 28 42 C 28 43.652344 26.207031 45 24 45 C 21.792969 45 20 43.652344 20 42 C 20 40.347656 21.792969 39 24 39 C 24.28125 39 24.5625 39.023438 24.839844 39.066406 C 25.128906 39.117188 25.425781 39.03125 25.648438 38.84375 C 25.871094 38.652344 26 38.375 26 38.078125 L 26 23.800781 Z M 13 52 C 12.449219 52 12 52.445313 12 53 L 12 55 C 12 55.554688 12.449219 56 13 56 C 13.550781 56 14 55.554688 14 55 L 14 53 C 14 52.445313 13.550781 52 13 52 Z M 18 52 C 17.449219 52 17 52.445313 17 53 L 17 55 C 17 55.554688 17.449219 56 18 56 C 18.550781 56 19 55.554688 19 55 L 19 53 C 19 52.445313 18.550781 52 18 52 Z M 23 52 C 22.449219 52 22 52.445313 22 53 L 22 55 C 22 55.554688 22.449219 56 23 56 C 23.550781 56 24 55.554688 24 55 L 24 53 C 24 52.445313 23.550781 52 23 52 Z M 28 52 C 27.449219 52 27 52.445313 27 53 L 27 55 C 27 55.554688 27.449219 56 28 56 C 28.550781 56 29 55.554688 29 55 L 29 53 C 29 52.445313 28.550781 52 28 52 Z M 33 52 C 32.449219 52 32 52.445313 32 53 L 32 55 C 32 55.554688 32.449219 56 33 56 C 33.550781 56 34 55.554688 34 55 L 34 53 C 34 52.445313 33.550781 52 33 52 Z M 38 52 C 37.449219 52 37 52.445313 37 53 L 37 55 C 37 55.554688 37.449219 56 38 56 C 38.550781 56 39 55.554688 39 55 L 39 53 C 39 52.445313 38.550781 52 38 52 Z M 43 52 C 42.449219 52 42 52.445313 42 53 L 42 55 C 42 55.554688 42.449219 56 43 56 C 43.550781 56 44 55.554688 44 55 L 44 53 C 44 52.445313 43.550781 52 43 52 Z M 48 52 C 47.449219 52 47 52.445313 47 53 L 47 55 C 47 55.554688 47.449219 56 48 56 C 48.550781 56 49 55.554688 49 55 L 49 53 C 49 52.445313 48.550781 52 48 52 Z "
                                                        fill="#ff9800"/>
                                                </g>
                                            </svg>
                                            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 64 64" data-testid="Icon"
                                                 height="80px" width="80px" v-if="item.type === 'video'">
                                                <g>
                                                    <path
                                                        d="M 23.65625 4 C 22.320313 4 21.0625 4.519531 20.121094 5.464844 L 11.464844 14.121094 C 10.519531 15.066406 10 16.320313 10 17.65625 L 10 57 C 10 58.652344 11.347656 60 13 60 L 53 60 C 54.652344 60 56 58.652344 56 57 L 56 7 C 56 5.347656 54.652344 4 53 4 Z M 24 6 L 53 6 C 53.550781 6 54 6.449219 54 7 L 54 57 C 54 57.550781 53.550781 58 53 58 L 13 58 C 12.449219 58 12 57.550781 12 57 L 12 18 L 21 18 C 22.652344 18 24 16.652344 24 15 Z M 22 6.5 L 22 15 C 22 15.550781 21.550781 16 21 16 L 12.5 16 C 12.613281 15.835938 12.738281 15.675781 12.878906 15.535156 L 21.535156 6.878906 C 21.679688 6.734375 21.835938 6.609375 22 6.5 Z M 28.023438 21.816406 C 27.671875 21.808594 27.316406 21.890625 26.996094 22.0625 C 26.355469 22.417969 25.964844 23.085938 25.964844 23.816406 L 25.964844 42.183594 C 25.964844 42.910156 26.355469 43.582031 26.996094 43.933594 C 27.296875 44.097656 27.632813 44.183594 27.964844 44.183594 C 28.335938 44.183594 28.707031 44.078125 29.03125 43.871094 L 43.53125 34.6875 C 44.113281 34.320313 44.464844 33.6875 44.464844 33 C 44.464844 32.308594 44.113281 31.679688 43.53125 31.3125 L 29.03125 22.125 C 28.722656 21.933594 28.375 21.828125 28.023438 21.816406 Z M 27.964844 23.816406 L 42.464844 33 L 27.964844 42.1875 Z M 15 52 C 14.449219 52 14 52.449219 14 53 L 14 55 C 14 55.550781 14.449219 56 15 56 C 15.550781 56 16 55.550781 16 55 L 16 53 C 16 52.449219 15.550781 52 15 52 Z M 20 52 C 19.449219 52 19 52.449219 19 53 L 19 55 C 19 55.550781 19.449219 56 20 56 C 20.550781 56 21 55.550781 21 55 L 21 53 C 21 52.449219 20.550781 52 20 52 Z M 25 52 C 24.449219 52 24 52.449219 24 53 L 24 55 C 24 55.550781 24.449219 56 25 56 C 25.550781 56 26 55.550781 26 55 L 26 53 C 26 52.449219 25.550781 52 25 52 Z M 30 52 C 29.449219 52 29 52.449219 29 53 L 29 55 C 29 55.550781 29.449219 56 30 56 C 30.550781 56 31 55.550781 31 55 L 31 53 C 31 52.449219 30.550781 52 30 52 Z M 35 52 C 34.449219 52 34 52.449219 34 53 L 34 55 C 34 55.550781 34.449219 56 35 56 C 35.550781 56 36 55.550781 36 55 L 36 53 C 36 52.449219 35.550781 52 35 52 Z M 40 52 C 39.449219 52 39 52.449219 39 53 L 39 55 C 39 55.550781 39.449219 56 40 56 C 40.550781 56 41 55.550781 41 55 L 41 53 C 41 52.449219 40.550781 52 40 52 Z M 45 52 C 44.449219 52 44 52.449219 44 53 L 44 55 C 44 55.550781 44.449219 56 45 56 C 45.550781 56 46 55.550781 46 55 L 46 53 C 46 52.449219 45.550781 52 45 52 Z M 50 52 C 49.449219 52 49 52.449219 49 53 L 49 55 C 49 55.550781 49.449219 56 50 56 C 50.550781 56 51 55.550781 51 55 L 51 53 C 51 52.449219 50.550781 52 50 52 Z "
                                                        fill="#f44336"/>
                                                </g>
                                            </svg>
                                            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 64 64" data-testid="Icon"
                                                 height="80px" width="80px" v-if="item.type === 'spreadsheet'">
                                                <g>
                                                    <path
                                                        d="M 35.136719 2.386719 C 34.917969 2.378906 34.699219 2.390625 34.480469 2.429688 L 5.304688 7.578125 C 3.390625 7.917969 2 9.574219 2 11.515625 L 2 50.484375 C 2 52.429688 3.390625 54.085938 5.304688 54.421875 L 34.480469 59.570313 C 34.652344 59.601563 34.828125 59.613281 35 59.613281 C 35.703125 59.613281 36.382813 59.371094 36.925781 58.914063 C 37.609375 58.34375 38 57.503906 38 56.613281 L 38 52 L 57 52 C 58.652344 52 60 50.652344 60 49 L 60 13 C 60 11.347656 58.652344 10 57 10 L 38 10 L 38 5.382813 C 38 4.496094 37.609375 3.65625 36.925781 3.085938 C 36.417969 2.65625 35.789063 2.414063 35.136719 2.386719 Z M 35.105469 4.390625 C 35.359375 4.414063 35.542969 4.535156 35.640625 4.617188 C 35.777344 4.730469 36 4.980469 36 5.382813 L 36 56.613281 C 36 57.019531 35.777344 57.269531 35.640625 57.382813 C 35.507813 57.496094 35.226563 57.671875 34.828125 57.601563 L 5.652344 52.453125 C 4.695313 52.285156 4 51.457031 4 50.484375 L 4 11.515625 C 4 10.542969 4.695313 9.714844 5.652344 9.546875 L 34.824219 4.398438 C 34.925781 4.382813 35.019531 4.378906 35.105469 4.390625 Z M 38 12 L 57 12 C 57.550781 12 58 12.449219 58 13 L 58 49 C 58 49.550781 57.550781 50 57 50 L 38 50 L 38 44 L 41 44 C 41.550781 44 42 43.554688 42 43 C 42 42.445313 41.550781 42 41 42 L 38 42 L 38 38 L 41 38 C 41.550781 38 42 37.554688 42 37 C 42 36.445313 41.550781 36 41 36 L 38 36 L 38 32 L 41 32 C 41.550781 32 42 31.554688 42 31 C 42 30.445313 41.550781 30 41 30 L 38 30 L 38 26 L 41 26 C 41.550781 26 42 25.554688 42 25 C 42 24.445313 41.550781 24 41 24 L 38 24 L 38 20 L 41 20 C 41.550781 20 42 19.554688 42 19 C 42 18.445313 41.550781 18 41 18 L 38 18 Z M 45 18 C 44.449219 18 44 18.445313 44 19 C 44 19.554688 44.449219 20 45 20 L 51 20 C 51.550781 20 52 19.554688 52 19 C 52 18.445313 51.550781 18 51 18 Z M 12.824219 20.015625 C 12.695313 20.039063 12.570313 20.085938 12.453125 20.160156 C 11.992188 20.460938 11.859375 21.082031 12.160156 21.546875 L 18.308594 31 L 12.160156 40.453125 C 11.859375 40.917969 11.992188 41.539063 12.453125 41.839844 C 12.625 41.949219 12.8125 42 13 42 C 13.324219 42 13.648438 41.839844 13.839844 41.546875 L 19.5 32.835938 L 25.160156 41.546875 C 25.351563 41.839844 25.675781 42 26 42 C 26.1875 42 26.375 41.949219 26.546875 41.839844 C 27.007813 41.539063 27.140625 40.917969 26.839844 40.453125 L 20.691406 31 L 26.839844 21.546875 C 27.140625 21.082031 27.007813 20.460938 26.546875 20.160156 C 26.082031 19.859375 25.460938 19.992188 25.160156 20.453125 L 19.5 29.164063 L 13.839844 20.453125 C 13.613281 20.105469 13.207031 19.945313 12.824219 20.015625 Z M 45 24 C 44.449219 24 44 24.445313 44 25 C 44 25.554688 44.449219 26 45 26 L 51 26 C 51.550781 26 52 25.554688 52 25 C 52 24.445313 51.550781 24 51 24 Z M 45 30 C 44.449219 30 44 30.445313 44 31 C 44 31.554688 44.449219 32 45 32 L 51 32 C 51.550781 32 52 31.554688 52 31 C 52 30.445313 51.550781 30 51 30 Z M 45 36 C 44.449219 36 44 36.445313 44 37 C 44 37.554688 44.449219 38 45 38 L 51 38 C 51.550781 38 52 37.554688 52 37 C 52 36.445313 51.550781 36 51 36 Z M 45 42 C 44.449219 42 44 42.445313 44 43 C 44 43.554688 44.449219 44 45 44 L 51 44 C 51.550781 44 52 43.554688 52 43 C 52 42.445313 51.550781 42 51 42 Z "
                                                        fill="#27764B"></path>
                                                </g>
                                            </svg>
                                            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 64 64" data-testid="Icon"
                                                 height="80px" width="80px" v-if="item.type === 'pdf'">
                                                <g>
                                                    <path
                                                        d="M 17.65625 4 C 16.320313 4 15.066406 4.519531 14.121094 5.464844 L 5.464844 14.121094 C 4.519531 15.066406 4 16.320313 4 17.65625 L 4 57 C 4 58.652344 5.347656 60 7 60 L 47 60 C 48.652344 60 50 58.652344 50 57 L 50 46 L 58 46 C 59.101563 46 60 45.101563 60 44 L 60 24 C 60 22.898438 59.101563 22 58 22 L 50 22 L 50 7 C 50 5.347656 48.652344 4 47 4 Z M 18 6 L 47 6 C 47.550781 6 48 6.449219 48 7 L 48 22 L 16 22 C 14.898438 22 14 22.898438 14 24 L 14 44 C 14 45.101563 14.898438 46 16 46 L 48 46 L 48 57 C 48 57.550781 47.550781 58 47 58 L 7 58 C 6.449219 58 6 57.550781 6 57 L 6 18 L 15 18 C 16.652344 18 18 16.652344 18 15 Z M 16 6.5 L 16 15 C 16 15.550781 15.550781 16 15 16 L 6.5 16 C 6.609375 15.835938 6.734375 15.679688 6.878906 15.535156 L 15.535156 6.878906 C 15.679688 6.734375 15.835938 6.609375 16 6.5 Z M 16 24 L 58 24 L 58 44 L 16 44 Z M 25 28 C 24.445313 28 24 28.449219 24 29 L 24 39 C 24 39.550781 24.445313 40 25 40 C 25.554688 40 26 39.550781 26 39 L 26 36 L 29 36 C 30.652344 36 32 34.652344 32 33 L 32 31 C 32 29.347656 30.652344 28 29 28 Z M 35 28 C 34.445313 28 34 28.449219 34 29 L 34 39 C 34 39.550781 34.445313 40 35 40 L 38 40 C 40.207031 40 42 38.207031 42 36 L 42 32 C 42 29.792969 40.207031 28 38 28 Z M 45 28 C 44.445313 28 44 28.449219 44 29 L 44 39 C 44 39.550781 44.445313 40 45 40 C 45.554688 40 46 39.550781 46 39 L 46 36 L 49 36 C 49.554688 36 50 35.550781 50 35 C 50 34.449219 49.554688 34 49 34 L 46 34 L 46 30 L 50 30 C 50.554688 30 51 29.550781 51 29 C 51 28.449219 50.554688 28 50 28 Z M 26 30 L 29 30 C 29.550781 30 30 30.449219 30 31 L 30 33 C 30 33.550781 29.550781 34 29 34 L 26 34 Z M 36 30 L 38 30 C 39.101563 30 40 30.898438 40 32 L 40 36 C 40 37.101563 39.101563 38 38 38 L 36 38 Z M 9 52 C 8.445313 52 8 52.449219 8 53 L 8 55 C 8 55.550781 8.445313 56 9 56 C 9.554688 56 10 55.550781 10 55 L 10 53 C 10 52.449219 9.554688 52 9 52 Z M 14 52 C 13.445313 52 13 52.449219 13 53 L 13 55 C 13 55.550781 13.445313 56 14 56 C 14.554688 56 15 55.550781 15 55 L 15 53 C 15 52.449219 14.554688 52 14 52 Z M 19 52 C 18.445313 52 18 52.449219 18 53 L 18 55 C 18 55.550781 18.445313 56 19 56 C 19.554688 56 20 55.550781 20 55 L 20 53 C 20 52.449219 19.554688 52 19 52 Z M 24 52 C 23.445313 52 23 52.449219 23 53 L 23 55 C 23 55.550781 23.445313 56 24 56 C 24.554688 56 25 55.550781 25 55 L 25 53 C 25 52.449219 24.554688 52 24 52 Z M 29 52 C 28.445313 52 28 52.449219 28 53 L 28 55 C 28 55.550781 28.445313 56 29 56 C 29.554688 56 30 55.550781 30 55 L 30 53 C 30 52.449219 29.554688 52 29 52 Z M 34 52 C 33.445313 52 33 52.449219 33 53 L 33 55 C 33 55.550781 33.445313 56 34 56 C 34.554688 56 35 55.550781 35 55 L 35 53 C 35 52.449219 34.554688 52 34 52 Z M 39 52 C 38.445313 52 38 52.449219 38 53 L 38 55 C 38 55.550781 38.445313 56 39 56 C 39.554688 56 40 55.550781 40 55 L 40 53 C 40 52.449219 39.554688 52 39 52 Z M 44 52 C 43.445313 52 43 52.449219 43 53 L 43 55 C 43 55.550781 43.445313 56 44 56 C 44.554688 56 45 55.550781 45 55 L 45 53 C 45 52.449219 44.554688 52 44 52 Z "
                                                        fill="#B51308"></path>
                                                </g>
                                            </svg>
                                            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 64 64" data-testid="Icon"
                                                 height="80px" width="80px" v-if="item.type === 'word'">
                                                <g>
                                                    <path
                                                        d="M 21.65625 4 C 20.320313 4 19.0625 4.519531 18.121094 5.464844 L 9.464844 14.121094 C 8.519531 15.066406 8 16.320313 8 17.65625 L 8 57 C 8 58.652344 9.347656 60 11 60 L 51 60 C 52.652344 60 54 58.652344 54 57 L 54 7 C 54 5.347656 52.652344 4 51 4 Z M 22 6 L 51 6 C 51.550781 6 52 6.449219 52 7 L 52 57 C 52 57.550781 51.550781 58 51 58 L 11 58 C 10.449219 58 10 57.550781 10 57 L 10 18 L 19 18 C 20.652344 18 22 16.652344 22 15 Z M 20 6.5 L 20 15 C 20 15.550781 19.550781 16 19 16 L 10.5 16 C 10.613281 15.832031 10.738281 15.675781 10.878906 15.535156 L 19.535156 6.878906 C 19.679688 6.734375 19.835938 6.609375 20 6.5 Z M 21.140625 23.011719 C 21.015625 22.992188 20.878906 22.996094 20.746094 23.03125 C 20.210938 23.175781 19.894531 23.722656 20.03125 24.253906 L 25.03125 43.253906 C 25.148438 43.691406 25.539063 43.996094 25.984375 44 L 26 44 C 26.441406 44 26.832031 43.710938 26.957031 43.28125 L 31 29.546875 L 35.042969 43.28125 C 35.167969 43.707031 35.558594 44 36 44 L 36.015625 44 C 36.460938 43.992188 36.851563 43.6875 36.96875 43.253906 L 41.96875 24.253906 C 42.105469 23.722656 41.789063 23.175781 41.253906 23.03125 C 40.71875 22.890625 40.171875 23.210938 40.03125 23.746094 L 35.945313 39.273438 L 31.957031 25.71875 C 31.832031 25.292969 31.445313 25 31 25 C 30.554688 25 30.167969 25.292969 30.042969 25.71875 L 26.054688 39.277344 L 21.96875 23.746094 C 21.863281 23.347656 21.527344 23.066406 21.140625 23.011719 Z M 13 52 C 12.449219 52 12 52.445313 12 53 L 12 55 C 12 55.554688 12.449219 56 13 56 C 13.550781 56 14 55.554688 14 55 L 14 53 C 14 52.445313 13.550781 52 13 52 Z M 18 52 C 17.449219 52 17 52.445313 17 53 L 17 55 C 17 55.554688 17.449219 56 18 56 C 18.550781 56 19 55.554688 19 55 L 19 53 C 19 52.445313 18.550781 52 18 52 Z M 23 52 C 22.449219 52 22 52.445313 22 53 L 22 55 C 22 55.554688 22.449219 56 23 56 C 23.550781 56 24 55.554688 24 55 L 24 53 C 24 52.445313 23.550781 52 23 52 Z M 28 52 C 27.449219 52 27 52.445313 27 53 L 27 55 C 27 55.554688 27.449219 56 28 56 C 28.550781 56 29 55.554688 29 55 L 29 53 C 29 52.445313 28.550781 52 28 52 Z M 33 52 C 32.449219 52 32 52.445313 32 53 L 32 55 C 32 55.554688 32.449219 56 33 56 C 33.550781 56 34 55.554688 34 55 L 34 53 C 34 52.445313 33.550781 52 33 52 Z M 38 52 C 37.449219 52 37 52.445313 37 53 L 37 55 C 37 55.554688 37.449219 56 38 56 C 38.550781 56 39 55.554688 39 55 L 39 53 C 39 52.445313 38.550781 52 38 52 Z M 43 52 C 42.449219 52 42 52.445313 42 53 L 42 55 C 42 55.554688 42.449219 56 43 56 C 43.550781 56 44 55.554688 44 55 L 44 53 C 44 52.445313 43.550781 52 43 52 Z M 48 52 C 47.449219 52 47 52.445313 47 53 L 47 55 C 47 55.554688 47.449219 56 48 56 C 48.550781 56 49 55.554688 49 55 L 49 53 C 49 52.445313 48.550781 52 48 52 Z "
                                                        fill="#1D59B9"></path>
                                                </g>
                                            </svg>
                                            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 64 64" data-testid="Icon"
                                                 height="80px" width="80px" v-if="item.type === 'powerPoint'">
                                                <g>
                                                    <path
                                                        d="M 35.136719 2.386719 C 34.917969 2.378906 34.699219 2.390625 34.480469 2.429688 L 5.304688 7.578125 C 3.390625 7.917969 2 9.574219 2 11.515625 L 2 50.484375 C 2 52.429688 3.390625 54.085938 5.304688 54.421875 L 34.480469 59.570313 C 34.652344 59.601563 34.828125 59.613281 35 59.613281 C 35.703125 59.613281 36.382813 59.371094 36.925781 58.914063 C 37.609375 58.34375 38 57.503906 38 56.613281 L 38 52 L 57 52 C 58.652344 52 60 50.652344 60 49 L 60 13 C 60 11.347656 58.652344 10 57 10 L 38 10 L 38 5.382813 C 38 4.496094 37.609375 3.65625 36.925781 3.085938 C 36.417969 2.65625 35.789063 2.414063 35.136719 2.386719 Z M 35.105469 4.390625 C 35.359375 4.414063 35.542969 4.535156 35.640625 4.617188 C 35.777344 4.730469 36 4.980469 36 5.382813 L 36 56.613281 C 36 57.019531 35.777344 57.269531 35.640625 57.382813 C 35.507813 57.496094 35.226563 57.667969 34.828125 57.601563 L 5.652344 52.453125 C 4.695313 52.285156 4 51.457031 4 50.484375 L 4 11.515625 C 4 10.542969 4.695313 9.714844 5.652344 9.546875 L 34.824219 4.398438 C 34.925781 4.382813 35.019531 4.378906 35.105469 4.390625 Z M 38 12 L 57 12 C 57.550781 12 58 12.449219 58 13 L 58 49 C 58 49.550781 57.550781 50 57 50 L 38 50 L 38 45.949219 L 52.949219 45.949219 C 53.5 45.949219 53.949219 45.554688 53.949219 45 C 53.949219 44.445313 53.5 44 52.949219 44 L 50 44 L 50 41 C 50 40.445313 49.550781 40 49 40 L 46 40 L 46 37 C 46 36.445313 45.550781 36 45 36 L 41 36 C 40.449219 36 40 36.445313 40 37 L 40 39 L 38 39 L 38 32.46875 C 39.46875 33.449219 41.203125 34 43 34 C 47.960938 34 52 29.964844 52 25 C 52 20.035156 47.960938 16 43 16 C 41.1875 16 39.464844 16.535156 38 17.519531 Z M 42 18.078125 L 42 24.832031 C 42 25.027344 42.070313 25.203125 42.171875 25.359375 C 42.21875 25.492188 42.289063 25.617188 42.394531 25.726563 L 47.234375 30.5625 C 46.054688 31.460938 44.589844 32 43 32 C 41.113281 32 39.316406 31.230469 38 29.886719 L 38 20.105469 C 39.089844 18.992188 40.484375 18.292969 42 18.078125 Z M 44 18.078125 C 47.386719 18.566406 50 21.480469 50 25 C 50 26.546875 49.488281 27.976563 48.636719 29.136719 L 44 24.5 Z M 15 20 C 14.449219 20 14 20.445313 14 21 L 14 41 C 14 41.554688 14.449219 42 15 42 C 15.550781 42 16 41.554688 16 41 L 16 34 L 21 34 C 23.757813 34 26 31.757813 26 29 L 26 25 C 26 22.242188 23.757813 20 21 20 Z M 16 22 L 21 22 C 22.652344 22 24 23.347656 24 25 L 24 29 C 24 30.652344 22.652344 32 21 32 L 16 32 Z M 42 38 L 44 38 L 44 44 L 42 44 Z M 38 41 L 40 41 L 40 44 L 38 44 Z M 46 42 L 48 42 L 48 44 L 46 44 Z "
                                                        fill="#D14B2B"></path>
                                                </g>
                                            </svg>
                                            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 64 64" data-testid="Icon"
                                                 height="80px" width="80px" v-if="item.type === 'archive'">
                                                <g>
                                                    <path
                                                        d="M 21.65625 4 C 20.320313 4 19.066406 4.519531 18.121094 5.464844 L 9.464844 14.121094 C 8.519531 15.066406 8 16.320313 8 17.65625 L 8 57 C 8 58.652344 9.347656 60 11 60 L 51 60 C 52.652344 60 54 58.652344 54 57 L 54 7 C 54 5.347656 52.652344 4 51 4 Z M 22 6 L 36 6 L 36 27.59375 C 35.144531 27.222656 34.210938 27 33.226563 27 L 32.773438 27 C 31.789063 27 30.859375 27.222656 30 27.59375 L 30 9 C 30 8.449219 29.554688 8 29 8 C 28.449219 8 28 8.449219 28 9 L 28 28.902344 C 27.015625 29.824219 26.277344 31.023438 25.953125 32.425781 L 24.875 37.097656 C 24.597656 38.292969 24.878906 39.53125 25.640625 40.488281 C 26.40625 41.449219 27.546875 42 28.769531 42 L 37.230469 42 C 38.457031 42 39.59375 41.449219 40.359375 40.488281 C 41.121094 39.53125 41.402344 38.292969 41.125 37.097656 L 40.046875 32.425781 C 39.726563 31.023438 38.984375 29.824219 38 28.902344 L 38 6 L 51 6 C 51.550781 6 52 6.449219 52 7 L 52 57 C 52 57.550781 51.550781 58 51 58 L 11 58 C 10.449219 58 10 57.550781 10 57 L 10 18 L 19 18 C 20.652344 18 22 16.652344 22 15 Z M 20 6.5 L 20 15 C 20 15.550781 19.550781 16 19 16 L 10.5 16 C 10.609375 15.835938 10.734375 15.679688 10.878906 15.535156 L 19.535156 6.878906 C 19.679688 6.738281 19.835938 6.609375 20 6.5 Z M 32 8 C 31.449219 8 31 8.445313 31 9 C 31 9.554688 31.449219 10 32 10 L 34 10 C 34.550781 10 35 9.554688 35 9 C 35 8.445313 34.550781 8 34 8 Z M 32 13 C 31.449219 13 31 13.445313 31 14 C 31 14.554688 31.449219 15 32 15 L 34 15 C 34.550781 15 35 14.554688 35 14 C 35 13.445313 34.550781 13 34 13 Z M 32 18 C 31.449219 18 31 18.445313 31 19 C 31 19.554688 31.449219 20 32 20 L 34 20 C 34.550781 20 35 19.554688 35 19 C 35 18.445313 34.550781 18 34 18 Z M 32 23 C 31.449219 23 31 23.445313 31 24 C 31 24.554688 31.449219 25 32 25 L 34 25 C 34.550781 25 35 24.554688 35 24 C 35 23.445313 34.550781 23 34 23 Z M 32.773438 29 L 33.226563 29 C 35.570313 29 37.574219 30.59375 38.097656 32.875 L 39.175781 37.550781 C 39.316406 38.148438 39.175781 38.765625 38.796875 39.246094 C 38.414063 39.722656 37.839844 40 37.230469 40 L 28.769531 40 C 28.160156 40 27.589844 39.722656 27.207031 39.246094 C 26.824219 38.765625 26.683594 38.148438 26.824219 37.550781 L 27.902344 32.875 C 28.429688 30.59375 30.429688 29 32.773438 29 Z M 31 34 C 30.449219 34 30 34.445313 30 35 C 30 35.554688 30.449219 36 31 36 L 35 36 C 35.550781 36 36 35.554688 36 35 C 36 34.445313 35.550781 34 35 34 Z M 13 52 C 12.449219 52 12 52.445313 12 53 C 12 53.554688 12.449219 54 13 54 L 17 54 C 17.550781 54 18 53.554688 18 53 C 18 52.445313 17.550781 52 17 52 Z M 21 52 C 20.449219 52 20 52.445313 20 53 C 20 53.554688 20.449219 54 21 54 L 49 54 C 49.550781 54 50 53.554688 50 53 C 50 52.445313 49.550781 52 49 52 Z "
                                                        fill="#37404D"></path>
                                                </g>
                                            </svg>
                                            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 64 64" data-testid="Icon"
                                                 height="80px" width="80px" v-if="item.type === 'file'">
                                                <g>
                                                    <path
                                                        d="M 23.65625 4 C 22.320313 4 21.066406 4.519531 20.121094 5.464844 L 11.464844 14.121094 C 10.519531 15.066406 10 16.320313 10 17.65625 L 10 57 C 10 58.652344 11.347656 60 13 60 L 53 60 C 54.652344 60 56 58.652344 56 57 L 56 7 C 56 5.347656 54.652344 4 53 4 Z M 24 6 L 53 6 C 53.550781 6 54 6.449219 54 7 L 54 57 C 54 57.550781 53.550781 58 53 58 L 13 58 C 12.449219 58 12 57.550781 12 57 L 12 18 L 21 18 C 22.652344 18 24 16.652344 24 15 Z M 22 6.5 L 22 15 C 22 15.550781 21.550781 16 21 16 L 12.5 16 C 12.605469 15.835938 12.734375 15.679688 12.878906 15.535156 L 21.535156 6.878906 C 21.679688 6.738281 21.835938 6.613281 22 6.5 Z M 21 22 C 20.449219 22 20 22.449219 20 23 C 20 23.550781 20.449219 24 21 24 L 37 24 C 37.550781 24 38 23.550781 38 23 C 38 22.449219 37.550781 22 37 22 Z M 41 22 C 40.449219 22 40 22.449219 40 23 C 40 23.550781 40.449219 24 41 24 L 45 24 C 45.550781 24 46 23.550781 46 23 C 46 22.449219 45.550781 22 45 22 Z M 21 26 C 20.449219 26 20 26.449219 20 27 C 20 27.550781 20.449219 28 21 28 L 41 28 C 41.550781 28 42 27.550781 42 27 C 42 26.449219 41.550781 26 41 26 Z M 21 32 C 20.449219 32 20 32.449219 20 33 C 20 33.550781 20.449219 34 21 34 L 43 34 C 43.550781 34 44 33.550781 44 33 C 44 32.449219 43.550781 32 43 32 Z M 21 36 C 20.449219 36 20 36.449219 20 37 C 20 37.550781 20.449219 38 21 38 L 33 38 C 33.550781 38 34 37.550781 34 37 C 34 36.449219 33.550781 36 33 36 Z M 15 50 C 14.449219 50 14 50.449219 14 51 L 14 53 C 14 53.550781 14.449219 54 15 54 C 15.550781 54 16 53.550781 16 53 L 16 51 C 16 50.449219 15.550781 50 15 50 Z M 20 50 C 19.449219 50 19 50.449219 19 51 L 19 53 C 19 53.550781 19.449219 54 20 54 C 20.550781 54 21 53.550781 21 53 L 21 51 C 21 50.449219 20.550781 50 20 50 Z M 25 50 C 24.449219 50 24 50.449219 24 51 L 24 53 C 24 53.550781 24.449219 54 25 54 C 25.550781 54 26 53.550781 26 53 L 26 51 C 26 50.449219 25.550781 50 25 50 Z M 30 50 C 29.449219 50 29 50.449219 29 51 L 29 53 C 29 53.550781 29.449219 54 30 54 C 30.550781 54 31 53.550781 31 53 L 31 51 C 31 50.449219 30.550781 50 30 50 Z M 35 50 C 34.449219 50 34 50.449219 34 51 L 34 53 C 34 53.550781 34.449219 54 35 54 C 35.550781 54 36 53.550781 36 53 L 36 51 C 36 50.449219 35.550781 50 35 50 Z M 40 50 C 39.449219 50 39 50.449219 39 51 L 39 53 C 39 53.550781 39.449219 54 40 54 C 40.550781 54 41 53.550781 41 53 L 41 51 C 41 50.449219 40.550781 50 40 50 Z M 45 50 C 44.449219 50 44 50.449219 44 51 L 44 53 C 44 53.550781 44.449219 54 45 54 C 45.550781 54 46 53.550781 46 53 L 46 51 C 46 50.449219 45.550781 50 45 50 Z M 50 50 C 49.449219 50 49 50.449219 49 51 L 49 53 C 49 53.550781 49.449219 54 50 54 C 50.550781 54 51 53.550781 51 53 L 51 51 C 51 50.449219 50.550781 50 50 50 Z"
                                                        fill="#37404D"></path>
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="text-center truncate"
                                             style="max-width: 100px">
                                            <span
                                                class="text-md font-bold">{{
                                                    item.name
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </VuePerfectScrollbar>
                    </div>
                    <div :class="isInfo ? 'vx-col info-file w-1/4 py-4' : 'hidden'" @mousedown.stop="">
                        <VuePerfectScrollbar :settings="settings" :key="$vs.rtl" class="vx-row scroll-view-folder"
                                             v-if="itemSelected">
                            <div class="vx-col w-full">
                                <div class="flex text-primary">
                                    <svg width="21px" height="21px" viewBox="0 0 512 512" xml:space="preserve"
                                         xmlns="http://www.w3.org/2000/svg" v-if="itemSelected.type === 'folder'"
                                         xmlns:xlink="http://www.w3.org/1999/xlink">
                            <path
                                d="M463.518,94.909H193.885v-10.37c0-22.908-18.574-41.482-41.482-41.482H48.699  c-22.908,0-41.482,18.574-41.482,41.482v51.852v72.593v217.78c0,22.907,18.574,41.482,41.482,41.482h414.819  c22.908,0,41.482-18.575,41.482-41.482V136.391C505,113.483,486.426,94.909,463.518,94.909z M27.958,84.539  c0-11.435,9.308-20.741,20.741-20.741h103.705c11.433,0,20.741,9.306,20.741,20.741v10.37v20.741h20.741h269.633  c11.433,0,20.741,9.306,20.741,20.741v20.741H27.958v-20.741V84.539z M463.518,447.506H48.699c-11.433,0-20.741-9.307-20.741-20.741  v-217.78v-31.111h456.301v248.892C484.259,438.198,474.952,447.506,463.518,447.506z"
                                fill="rgba(var(--vs-primary), 1)"/>
                        </svg>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 64 64" data-testid="Icon"
                                         height="21px" width="21px" v-if="itemSelected.type === 'audio'">
                                        <g>
                                            <path
                                                d="M 21.65625 4 C 20.320313 4 19.0625 4.519531 18.121094 5.464844 L 9.464844 14.121094 C 8.519531 15.066406 8 16.320313 8 17.65625 L 8 57 C 8 58.652344 9.347656 60 11 60 L 51 60 C 52.652344 60 54 58.652344 54 57 L 54 7 C 54 5.347656 52.652344 4 51 4 Z M 22 6 L 51 6 C 51.550781 6 52 6.449219 52 7 L 52 57 C 52 57.550781 51.550781 58 51 58 L 11 58 C 10.449219 58 10 57.550781 10 57 L 10 18 L 19 18 C 20.652344 18 22 16.652344 22 15 Z M 20 6.5 L 20 15 C 20 15.550781 19.550781 16 19 16 L 10.5 16 C 10.609375 15.835938 10.734375 15.679688 10.878906 15.535156 L 19.535156 6.878906 C 19.679688 6.734375 19.835938 6.609375 20 6.5 Z M 42.78125 18.023438 L 24.78125 22.023438 C 24.328125 22.125 24 22.53125 24 23 L 24 37 C 20.691406 37 18 39.242188 18 42 C 18 44.757813 20.691406 47 24 47 C 27.308594 47 30 44.757813 30 42 L 30 29.910156 L 38 28.136719 L 38 33 C 34.691406 33 32 35.242188 32 38 C 32 40.757813 34.691406 43 38 43 C 41.308594 43 44 40.757813 44 38 L 44 19 C 44 18.695313 43.863281 18.410156 43.625 18.21875 C 43.390625 18.03125 43.082031 17.960938 42.78125 18.023438 Z M 42 20.246094 L 42 38 C 42 39.652344 40.207031 41 38 41 C 35.792969 41 34 39.652344 34 38 C 34 36.347656 35.792969 35 38 35 C 38.28125 35 38.5625 35.023438 38.839844 35.066406 C 39.128906 35.117188 39.421875 35.03125 39.648438 34.84375 C 39.871094 34.652344 40 34.375 40 34.078125 L 40 26.890625 C 40 26.585938 39.863281 26.300781 39.625 26.109375 C 39.390625 25.921875 39.078125 25.847656 38.78125 25.910156 L 28.78125 28.136719 C 28.328125 28.238281 28 28.644531 28 29.109375 L 28 42 C 28 43.652344 26.207031 45 24 45 C 21.792969 45 20 43.652344 20 42 C 20 40.347656 21.792969 39 24 39 C 24.28125 39 24.5625 39.023438 24.839844 39.066406 C 25.128906 39.117188 25.425781 39.03125 25.648438 38.84375 C 25.871094 38.652344 26 38.375 26 38.078125 L 26 23.800781 Z M 13 52 C 12.449219 52 12 52.445313 12 53 L 12 55 C 12 55.554688 12.449219 56 13 56 C 13.550781 56 14 55.554688 14 55 L 14 53 C 14 52.445313 13.550781 52 13 52 Z M 18 52 C 17.449219 52 17 52.445313 17 53 L 17 55 C 17 55.554688 17.449219 56 18 56 C 18.550781 56 19 55.554688 19 55 L 19 53 C 19 52.445313 18.550781 52 18 52 Z M 23 52 C 22.449219 52 22 52.445313 22 53 L 22 55 C 22 55.554688 22.449219 56 23 56 C 23.550781 56 24 55.554688 24 55 L 24 53 C 24 52.445313 23.550781 52 23 52 Z M 28 52 C 27.449219 52 27 52.445313 27 53 L 27 55 C 27 55.554688 27.449219 56 28 56 C 28.550781 56 29 55.554688 29 55 L 29 53 C 29 52.445313 28.550781 52 28 52 Z M 33 52 C 32.449219 52 32 52.445313 32 53 L 32 55 C 32 55.554688 32.449219 56 33 56 C 33.550781 56 34 55.554688 34 55 L 34 53 C 34 52.445313 33.550781 52 33 52 Z M 38 52 C 37.449219 52 37 52.445313 37 53 L 37 55 C 37 55.554688 37.449219 56 38 56 C 38.550781 56 39 55.554688 39 55 L 39 53 C 39 52.445313 38.550781 52 38 52 Z M 43 52 C 42.449219 52 42 52.445313 42 53 L 42 55 C 42 55.554688 42.449219 56 43 56 C 43.550781 56 44 55.554688 44 55 L 44 53 C 44 52.445313 43.550781 52 43 52 Z M 48 52 C 47.449219 52 47 52.445313 47 53 L 47 55 C 47 55.554688 47.449219 56 48 56 C 48.550781 56 49 55.554688 49 55 L 49 53 C 49 52.445313 48.550781 52 48 52 Z "
                                                fill="rgba(var(--vs-primary), 1)"/>
                                        </g>
                                    </svg>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 64 64" data-testid="Icon"
                                         height="21px" width="21px" v-if="itemSelected.type === 'video'">
                                        <g>
                                            <path
                                                d="M 23.65625 4 C 22.320313 4 21.0625 4.519531 20.121094 5.464844 L 11.464844 14.121094 C 10.519531 15.066406 10 16.320313 10 17.65625 L 10 57 C 10 58.652344 11.347656 60 13 60 L 53 60 C 54.652344 60 56 58.652344 56 57 L 56 7 C 56 5.347656 54.652344 4 53 4 Z M 24 6 L 53 6 C 53.550781 6 54 6.449219 54 7 L 54 57 C 54 57.550781 53.550781 58 53 58 L 13 58 C 12.449219 58 12 57.550781 12 57 L 12 18 L 21 18 C 22.652344 18 24 16.652344 24 15 Z M 22 6.5 L 22 15 C 22 15.550781 21.550781 16 21 16 L 12.5 16 C 12.613281 15.835938 12.738281 15.675781 12.878906 15.535156 L 21.535156 6.878906 C 21.679688 6.734375 21.835938 6.609375 22 6.5 Z M 28.023438 21.816406 C 27.671875 21.808594 27.316406 21.890625 26.996094 22.0625 C 26.355469 22.417969 25.964844 23.085938 25.964844 23.816406 L 25.964844 42.183594 C 25.964844 42.910156 26.355469 43.582031 26.996094 43.933594 C 27.296875 44.097656 27.632813 44.183594 27.964844 44.183594 C 28.335938 44.183594 28.707031 44.078125 29.03125 43.871094 L 43.53125 34.6875 C 44.113281 34.320313 44.464844 33.6875 44.464844 33 C 44.464844 32.308594 44.113281 31.679688 43.53125 31.3125 L 29.03125 22.125 C 28.722656 21.933594 28.375 21.828125 28.023438 21.816406 Z M 27.964844 23.816406 L 42.464844 33 L 27.964844 42.1875 Z M 15 52 C 14.449219 52 14 52.449219 14 53 L 14 55 C 14 55.550781 14.449219 56 15 56 C 15.550781 56 16 55.550781 16 55 L 16 53 C 16 52.449219 15.550781 52 15 52 Z M 20 52 C 19.449219 52 19 52.449219 19 53 L 19 55 C 19 55.550781 19.449219 56 20 56 C 20.550781 56 21 55.550781 21 55 L 21 53 C 21 52.449219 20.550781 52 20 52 Z M 25 52 C 24.449219 52 24 52.449219 24 53 L 24 55 C 24 55.550781 24.449219 56 25 56 C 25.550781 56 26 55.550781 26 55 L 26 53 C 26 52.449219 25.550781 52 25 52 Z M 30 52 C 29.449219 52 29 52.449219 29 53 L 29 55 C 29 55.550781 29.449219 56 30 56 C 30.550781 56 31 55.550781 31 55 L 31 53 C 31 52.449219 30.550781 52 30 52 Z M 35 52 C 34.449219 52 34 52.449219 34 53 L 34 55 C 34 55.550781 34.449219 56 35 56 C 35.550781 56 36 55.550781 36 55 L 36 53 C 36 52.449219 35.550781 52 35 52 Z M 40 52 C 39.449219 52 39 52.449219 39 53 L 39 55 C 39 55.550781 39.449219 56 40 56 C 40.550781 56 41 55.550781 41 55 L 41 53 C 41 52.449219 40.550781 52 40 52 Z M 45 52 C 44.449219 52 44 52.449219 44 53 L 44 55 C 44 55.550781 44.449219 56 45 56 C 45.550781 56 46 55.550781 46 55 L 46 53 C 46 52.449219 45.550781 52 45 52 Z M 50 52 C 49.449219 52 49 52.449219 49 53 L 49 55 C 49 55.550781 49.449219 56 50 56 C 50.550781 56 51 55.550781 51 55 L 51 53 C 51 52.449219 50.550781 52 50 52 Z "
                                                fill="rgba(var(--vs-primary), 1)"/>
                                        </g>
                                    </svg>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 64 64" data-testid="Icon"
                                         height="21px" width="21px" v-if="itemSelected.type === 'spreadsheet'">
                                        <g>
                                            <path
                                                d="M 35.136719 2.386719 C 34.917969 2.378906 34.699219 2.390625 34.480469 2.429688 L 5.304688 7.578125 C 3.390625 7.917969 2 9.574219 2 11.515625 L 2 50.484375 C 2 52.429688 3.390625 54.085938 5.304688 54.421875 L 34.480469 59.570313 C 34.652344 59.601563 34.828125 59.613281 35 59.613281 C 35.703125 59.613281 36.382813 59.371094 36.925781 58.914063 C 37.609375 58.34375 38 57.503906 38 56.613281 L 38 52 L 57 52 C 58.652344 52 60 50.652344 60 49 L 60 13 C 60 11.347656 58.652344 10 57 10 L 38 10 L 38 5.382813 C 38 4.496094 37.609375 3.65625 36.925781 3.085938 C 36.417969 2.65625 35.789063 2.414063 35.136719 2.386719 Z M 35.105469 4.390625 C 35.359375 4.414063 35.542969 4.535156 35.640625 4.617188 C 35.777344 4.730469 36 4.980469 36 5.382813 L 36 56.613281 C 36 57.019531 35.777344 57.269531 35.640625 57.382813 C 35.507813 57.496094 35.226563 57.671875 34.828125 57.601563 L 5.652344 52.453125 C 4.695313 52.285156 4 51.457031 4 50.484375 L 4 11.515625 C 4 10.542969 4.695313 9.714844 5.652344 9.546875 L 34.824219 4.398438 C 34.925781 4.382813 35.019531 4.378906 35.105469 4.390625 Z M 38 12 L 57 12 C 57.550781 12 58 12.449219 58 13 L 58 49 C 58 49.550781 57.550781 50 57 50 L 38 50 L 38 44 L 41 44 C 41.550781 44 42 43.554688 42 43 C 42 42.445313 41.550781 42 41 42 L 38 42 L 38 38 L 41 38 C 41.550781 38 42 37.554688 42 37 C 42 36.445313 41.550781 36 41 36 L 38 36 L 38 32 L 41 32 C 41.550781 32 42 31.554688 42 31 C 42 30.445313 41.550781 30 41 30 L 38 30 L 38 26 L 41 26 C 41.550781 26 42 25.554688 42 25 C 42 24.445313 41.550781 24 41 24 L 38 24 L 38 20 L 41 20 C 41.550781 20 42 19.554688 42 19 C 42 18.445313 41.550781 18 41 18 L 38 18 Z M 45 18 C 44.449219 18 44 18.445313 44 19 C 44 19.554688 44.449219 20 45 20 L 51 20 C 51.550781 20 52 19.554688 52 19 C 52 18.445313 51.550781 18 51 18 Z M 12.824219 20.015625 C 12.695313 20.039063 12.570313 20.085938 12.453125 20.160156 C 11.992188 20.460938 11.859375 21.082031 12.160156 21.546875 L 18.308594 31 L 12.160156 40.453125 C 11.859375 40.917969 11.992188 41.539063 12.453125 41.839844 C 12.625 41.949219 12.8125 42 13 42 C 13.324219 42 13.648438 41.839844 13.839844 41.546875 L 19.5 32.835938 L 25.160156 41.546875 C 25.351563 41.839844 25.675781 42 26 42 C 26.1875 42 26.375 41.949219 26.546875 41.839844 C 27.007813 41.539063 27.140625 40.917969 26.839844 40.453125 L 20.691406 31 L 26.839844 21.546875 C 27.140625 21.082031 27.007813 20.460938 26.546875 20.160156 C 26.082031 19.859375 25.460938 19.992188 25.160156 20.453125 L 19.5 29.164063 L 13.839844 20.453125 C 13.613281 20.105469 13.207031 19.945313 12.824219 20.015625 Z M 45 24 C 44.449219 24 44 24.445313 44 25 C 44 25.554688 44.449219 26 45 26 L 51 26 C 51.550781 26 52 25.554688 52 25 C 52 24.445313 51.550781 24 51 24 Z M 45 30 C 44.449219 30 44 30.445313 44 31 C 44 31.554688 44.449219 32 45 32 L 51 32 C 51.550781 32 52 31.554688 52 31 C 52 30.445313 51.550781 30 51 30 Z M 45 36 C 44.449219 36 44 36.445313 44 37 C 44 37.554688 44.449219 38 45 38 L 51 38 C 51.550781 38 52 37.554688 52 37 C 52 36.445313 51.550781 36 51 36 Z M 45 42 C 44.449219 42 44 42.445313 44 43 C 44 43.554688 44.449219 44 45 44 L 51 44 C 51.550781 44 52 43.554688 52 43 C 52 42.445313 51.550781 42 51 42 Z "
                                                fill="rgba(var(--vs-primary), 1)"></path>
                                        </g>
                                    </svg>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 64 64" data-testid="Icon"
                                         height="21px" width="21px" v-if="itemSelected.type === 'pdf'">
                                        <g>
                                            <path
                                                d="M 17.65625 4 C 16.320313 4 15.066406 4.519531 14.121094 5.464844 L 5.464844 14.121094 C 4.519531 15.066406 4 16.320313 4 17.65625 L 4 57 C 4 58.652344 5.347656 60 7 60 L 47 60 C 48.652344 60 50 58.652344 50 57 L 50 46 L 58 46 C 59.101563 46 60 45.101563 60 44 L 60 24 C 60 22.898438 59.101563 22 58 22 L 50 22 L 50 7 C 50 5.347656 48.652344 4 47 4 Z M 18 6 L 47 6 C 47.550781 6 48 6.449219 48 7 L 48 22 L 16 22 C 14.898438 22 14 22.898438 14 24 L 14 44 C 14 45.101563 14.898438 46 16 46 L 48 46 L 48 57 C 48 57.550781 47.550781 58 47 58 L 7 58 C 6.449219 58 6 57.550781 6 57 L 6 18 L 15 18 C 16.652344 18 18 16.652344 18 15 Z M 16 6.5 L 16 15 C 16 15.550781 15.550781 16 15 16 L 6.5 16 C 6.609375 15.835938 6.734375 15.679688 6.878906 15.535156 L 15.535156 6.878906 C 15.679688 6.734375 15.835938 6.609375 16 6.5 Z M 16 24 L 58 24 L 58 44 L 16 44 Z M 25 28 C 24.445313 28 24 28.449219 24 29 L 24 39 C 24 39.550781 24.445313 40 25 40 C 25.554688 40 26 39.550781 26 39 L 26 36 L 29 36 C 30.652344 36 32 34.652344 32 33 L 32 31 C 32 29.347656 30.652344 28 29 28 Z M 35 28 C 34.445313 28 34 28.449219 34 29 L 34 39 C 34 39.550781 34.445313 40 35 40 L 38 40 C 40.207031 40 42 38.207031 42 36 L 42 32 C 42 29.792969 40.207031 28 38 28 Z M 45 28 C 44.445313 28 44 28.449219 44 29 L 44 39 C 44 39.550781 44.445313 40 45 40 C 45.554688 40 46 39.550781 46 39 L 46 36 L 49 36 C 49.554688 36 50 35.550781 50 35 C 50 34.449219 49.554688 34 49 34 L 46 34 L 46 30 L 50 30 C 50.554688 30 51 29.550781 51 29 C 51 28.449219 50.554688 28 50 28 Z M 26 30 L 29 30 C 29.550781 30 30 30.449219 30 31 L 30 33 C 30 33.550781 29.550781 34 29 34 L 26 34 Z M 36 30 L 38 30 C 39.101563 30 40 30.898438 40 32 L 40 36 C 40 37.101563 39.101563 38 38 38 L 36 38 Z M 9 52 C 8.445313 52 8 52.449219 8 53 L 8 55 C 8 55.550781 8.445313 56 9 56 C 9.554688 56 10 55.550781 10 55 L 10 53 C 10 52.449219 9.554688 52 9 52 Z M 14 52 C 13.445313 52 13 52.449219 13 53 L 13 55 C 13 55.550781 13.445313 56 14 56 C 14.554688 56 15 55.550781 15 55 L 15 53 C 15 52.449219 14.554688 52 14 52 Z M 19 52 C 18.445313 52 18 52.449219 18 53 L 18 55 C 18 55.550781 18.445313 56 19 56 C 19.554688 56 20 55.550781 20 55 L 20 53 C 20 52.449219 19.554688 52 19 52 Z M 24 52 C 23.445313 52 23 52.449219 23 53 L 23 55 C 23 55.550781 23.445313 56 24 56 C 24.554688 56 25 55.550781 25 55 L 25 53 C 25 52.449219 24.554688 52 24 52 Z M 29 52 C 28.445313 52 28 52.449219 28 53 L 28 55 C 28 55.550781 28.445313 56 29 56 C 29.554688 56 30 55.550781 30 55 L 30 53 C 30 52.449219 29.554688 52 29 52 Z M 34 52 C 33.445313 52 33 52.449219 33 53 L 33 55 C 33 55.550781 33.445313 56 34 56 C 34.554688 56 35 55.550781 35 55 L 35 53 C 35 52.449219 34.554688 52 34 52 Z M 39 52 C 38.445313 52 38 52.449219 38 53 L 38 55 C 38 55.550781 38.445313 56 39 56 C 39.554688 56 40 55.550781 40 55 L 40 53 C 40 52.449219 39.554688 52 39 52 Z M 44 52 C 43.445313 52 43 52.449219 43 53 L 43 55 C 43 55.550781 43.445313 56 44 56 C 44.554688 56 45 55.550781 45 55 L 45 53 C 45 52.449219 44.554688 52 44 52 Z "
                                                fill="rgba(var(--vs-primary), 1)"></path>
                                        </g>
                                    </svg>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 64 64" data-testid="Icon"
                                         height="21px" width="21px" v-if="itemSelected.type === 'word'">
                                        <g>
                                            <path
                                                d="M 21.65625 4 C 20.320313 4 19.0625 4.519531 18.121094 5.464844 L 9.464844 14.121094 C 8.519531 15.066406 8 16.320313 8 17.65625 L 8 57 C 8 58.652344 9.347656 60 11 60 L 51 60 C 52.652344 60 54 58.652344 54 57 L 54 7 C 54 5.347656 52.652344 4 51 4 Z M 22 6 L 51 6 C 51.550781 6 52 6.449219 52 7 L 52 57 C 52 57.550781 51.550781 58 51 58 L 11 58 C 10.449219 58 10 57.550781 10 57 L 10 18 L 19 18 C 20.652344 18 22 16.652344 22 15 Z M 20 6.5 L 20 15 C 20 15.550781 19.550781 16 19 16 L 10.5 16 C 10.613281 15.832031 10.738281 15.675781 10.878906 15.535156 L 19.535156 6.878906 C 19.679688 6.734375 19.835938 6.609375 20 6.5 Z M 21.140625 23.011719 C 21.015625 22.992188 20.878906 22.996094 20.746094 23.03125 C 20.210938 23.175781 19.894531 23.722656 20.03125 24.253906 L 25.03125 43.253906 C 25.148438 43.691406 25.539063 43.996094 25.984375 44 L 26 44 C 26.441406 44 26.832031 43.710938 26.957031 43.28125 L 31 29.546875 L 35.042969 43.28125 C 35.167969 43.707031 35.558594 44 36 44 L 36.015625 44 C 36.460938 43.992188 36.851563 43.6875 36.96875 43.253906 L 41.96875 24.253906 C 42.105469 23.722656 41.789063 23.175781 41.253906 23.03125 C 40.71875 22.890625 40.171875 23.210938 40.03125 23.746094 L 35.945313 39.273438 L 31.957031 25.71875 C 31.832031 25.292969 31.445313 25 31 25 C 30.554688 25 30.167969 25.292969 30.042969 25.71875 L 26.054688 39.277344 L 21.96875 23.746094 C 21.863281 23.347656 21.527344 23.066406 21.140625 23.011719 Z M 13 52 C 12.449219 52 12 52.445313 12 53 L 12 55 C 12 55.554688 12.449219 56 13 56 C 13.550781 56 14 55.554688 14 55 L 14 53 C 14 52.445313 13.550781 52 13 52 Z M 18 52 C 17.449219 52 17 52.445313 17 53 L 17 55 C 17 55.554688 17.449219 56 18 56 C 18.550781 56 19 55.554688 19 55 L 19 53 C 19 52.445313 18.550781 52 18 52 Z M 23 52 C 22.449219 52 22 52.445313 22 53 L 22 55 C 22 55.554688 22.449219 56 23 56 C 23.550781 56 24 55.554688 24 55 L 24 53 C 24 52.445313 23.550781 52 23 52 Z M 28 52 C 27.449219 52 27 52.445313 27 53 L 27 55 C 27 55.554688 27.449219 56 28 56 C 28.550781 56 29 55.554688 29 55 L 29 53 C 29 52.445313 28.550781 52 28 52 Z M 33 52 C 32.449219 52 32 52.445313 32 53 L 32 55 C 32 55.554688 32.449219 56 33 56 C 33.550781 56 34 55.554688 34 55 L 34 53 C 34 52.445313 33.550781 52 33 52 Z M 38 52 C 37.449219 52 37 52.445313 37 53 L 37 55 C 37 55.554688 37.449219 56 38 56 C 38.550781 56 39 55.554688 39 55 L 39 53 C 39 52.445313 38.550781 52 38 52 Z M 43 52 C 42.449219 52 42 52.445313 42 53 L 42 55 C 42 55.554688 42.449219 56 43 56 C 43.550781 56 44 55.554688 44 55 L 44 53 C 44 52.445313 43.550781 52 43 52 Z M 48 52 C 47.449219 52 47 52.445313 47 53 L 47 55 C 47 55.554688 47.449219 56 48 56 C 48.550781 56 49 55.554688 49 55 L 49 53 C 49 52.445313 48.550781 52 48 52 Z "
                                                fill="rgba(var(--vs-primary), 1)"></path>
                                        </g>
                                    </svg>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 64 64" data-testid="Icon"
                                         height="21px" width="21px" v-if="itemSelected.type === 'powerPoint'">
                                        <g>
                                            <path
                                                d="M 35.136719 2.386719 C 34.917969 2.378906 34.699219 2.390625 34.480469 2.429688 L 5.304688 7.578125 C 3.390625 7.917969 2 9.574219 2 11.515625 L 2 50.484375 C 2 52.429688 3.390625 54.085938 5.304688 54.421875 L 34.480469 59.570313 C 34.652344 59.601563 34.828125 59.613281 35 59.613281 C 35.703125 59.613281 36.382813 59.371094 36.925781 58.914063 C 37.609375 58.34375 38 57.503906 38 56.613281 L 38 52 L 57 52 C 58.652344 52 60 50.652344 60 49 L 60 13 C 60 11.347656 58.652344 10 57 10 L 38 10 L 38 5.382813 C 38 4.496094 37.609375 3.65625 36.925781 3.085938 C 36.417969 2.65625 35.789063 2.414063 35.136719 2.386719 Z M 35.105469 4.390625 C 35.359375 4.414063 35.542969 4.535156 35.640625 4.617188 C 35.777344 4.730469 36 4.980469 36 5.382813 L 36 56.613281 C 36 57.019531 35.777344 57.269531 35.640625 57.382813 C 35.507813 57.496094 35.226563 57.667969 34.828125 57.601563 L 5.652344 52.453125 C 4.695313 52.285156 4 51.457031 4 50.484375 L 4 11.515625 C 4 10.542969 4.695313 9.714844 5.652344 9.546875 L 34.824219 4.398438 C 34.925781 4.382813 35.019531 4.378906 35.105469 4.390625 Z M 38 12 L 57 12 C 57.550781 12 58 12.449219 58 13 L 58 49 C 58 49.550781 57.550781 50 57 50 L 38 50 L 38 45.949219 L 52.949219 45.949219 C 53.5 45.949219 53.949219 45.554688 53.949219 45 C 53.949219 44.445313 53.5 44 52.949219 44 L 50 44 L 50 41 C 50 40.445313 49.550781 40 49 40 L 46 40 L 46 37 C 46 36.445313 45.550781 36 45 36 L 41 36 C 40.449219 36 40 36.445313 40 37 L 40 39 L 38 39 L 38 32.46875 C 39.46875 33.449219 41.203125 34 43 34 C 47.960938 34 52 29.964844 52 25 C 52 20.035156 47.960938 16 43 16 C 41.1875 16 39.464844 16.535156 38 17.519531 Z M 42 18.078125 L 42 24.832031 C 42 25.027344 42.070313 25.203125 42.171875 25.359375 C 42.21875 25.492188 42.289063 25.617188 42.394531 25.726563 L 47.234375 30.5625 C 46.054688 31.460938 44.589844 32 43 32 C 41.113281 32 39.316406 31.230469 38 29.886719 L 38 20.105469 C 39.089844 18.992188 40.484375 18.292969 42 18.078125 Z M 44 18.078125 C 47.386719 18.566406 50 21.480469 50 25 C 50 26.546875 49.488281 27.976563 48.636719 29.136719 L 44 24.5 Z M 15 20 C 14.449219 20 14 20.445313 14 21 L 14 41 C 14 41.554688 14.449219 42 15 42 C 15.550781 42 16 41.554688 16 41 L 16 34 L 21 34 C 23.757813 34 26 31.757813 26 29 L 26 25 C 26 22.242188 23.757813 20 21 20 Z M 16 22 L 21 22 C 22.652344 22 24 23.347656 24 25 L 24 29 C 24 30.652344 22.652344 32 21 32 L 16 32 Z M 42 38 L 44 38 L 44 44 L 42 44 Z M 38 41 L 40 41 L 40 44 L 38 44 Z M 46 42 L 48 42 L 48 44 L 46 44 Z "
                                                fill="rgba(var(--vs-primary), 1)"></path>
                                        </g>
                                    </svg>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 64 64" data-testid="Icon"
                                         height="21px" width="21px" v-if="itemSelected.type === 'archive'">
                                        <g>
                                            <path
                                                d="M 21.65625 4 C 20.320313 4 19.066406 4.519531 18.121094 5.464844 L 9.464844 14.121094 C 8.519531 15.066406 8 16.320313 8 17.65625 L 8 57 C 8 58.652344 9.347656 60 11 60 L 51 60 C 52.652344 60 54 58.652344 54 57 L 54 7 C 54 5.347656 52.652344 4 51 4 Z M 22 6 L 36 6 L 36 27.59375 C 35.144531 27.222656 34.210938 27 33.226563 27 L 32.773438 27 C 31.789063 27 30.859375 27.222656 30 27.59375 L 30 9 C 30 8.449219 29.554688 8 29 8 C 28.449219 8 28 8.449219 28 9 L 28 28.902344 C 27.015625 29.824219 26.277344 31.023438 25.953125 32.425781 L 24.875 37.097656 C 24.597656 38.292969 24.878906 39.53125 25.640625 40.488281 C 26.40625 41.449219 27.546875 42 28.769531 42 L 37.230469 42 C 38.457031 42 39.59375 41.449219 40.359375 40.488281 C 41.121094 39.53125 41.402344 38.292969 41.125 37.097656 L 40.046875 32.425781 C 39.726563 31.023438 38.984375 29.824219 38 28.902344 L 38 6 L 51 6 C 51.550781 6 52 6.449219 52 7 L 52 57 C 52 57.550781 51.550781 58 51 58 L 11 58 C 10.449219 58 10 57.550781 10 57 L 10 18 L 19 18 C 20.652344 18 22 16.652344 22 15 Z M 20 6.5 L 20 15 C 20 15.550781 19.550781 16 19 16 L 10.5 16 C 10.609375 15.835938 10.734375 15.679688 10.878906 15.535156 L 19.535156 6.878906 C 19.679688 6.738281 19.835938 6.609375 20 6.5 Z M 32 8 C 31.449219 8 31 8.445313 31 9 C 31 9.554688 31.449219 10 32 10 L 34 10 C 34.550781 10 35 9.554688 35 9 C 35 8.445313 34.550781 8 34 8 Z M 32 13 C 31.449219 13 31 13.445313 31 14 C 31 14.554688 31.449219 15 32 15 L 34 15 C 34.550781 15 35 14.554688 35 14 C 35 13.445313 34.550781 13 34 13 Z M 32 18 C 31.449219 18 31 18.445313 31 19 C 31 19.554688 31.449219 20 32 20 L 34 20 C 34.550781 20 35 19.554688 35 19 C 35 18.445313 34.550781 18 34 18 Z M 32 23 C 31.449219 23 31 23.445313 31 24 C 31 24.554688 31.449219 25 32 25 L 34 25 C 34.550781 25 35 24.554688 35 24 C 35 23.445313 34.550781 23 34 23 Z M 32.773438 29 L 33.226563 29 C 35.570313 29 37.574219 30.59375 38.097656 32.875 L 39.175781 37.550781 C 39.316406 38.148438 39.175781 38.765625 38.796875 39.246094 C 38.414063 39.722656 37.839844 40 37.230469 40 L 28.769531 40 C 28.160156 40 27.589844 39.722656 27.207031 39.246094 C 26.824219 38.765625 26.683594 38.148438 26.824219 37.550781 L 27.902344 32.875 C 28.429688 30.59375 30.429688 29 32.773438 29 Z M 31 34 C 30.449219 34 30 34.445313 30 35 C 30 35.554688 30.449219 36 31 36 L 35 36 C 35.550781 36 36 35.554688 36 35 C 36 34.445313 35.550781 34 35 34 Z M 13 52 C 12.449219 52 12 52.445313 12 53 C 12 53.554688 12.449219 54 13 54 L 17 54 C 17.550781 54 18 53.554688 18 53 C 18 52.445313 17.550781 52 17 52 Z M 21 52 C 20.449219 52 20 52.445313 20 53 C 20 53.554688 20.449219 54 21 54 L 49 54 C 49.550781 54 50 53.554688 50 53 C 50 52.445313 49.550781 52 49 52 Z "
                                                fill="rgba(var(--vs-primary), 1)"></path>
                                        </g>
                                    </svg>
                                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 64 64" data-testid="Icon"
                                         height="21px" width="21px" v-if="itemSelected.type === 'file'">
                                        <g>
                                            <path
                                                d="M 23.65625 4 C 22.320313 4 21.066406 4.519531 20.121094 5.464844 L 11.464844 14.121094 C 10.519531 15.066406 10 16.320313 10 17.65625 L 10 57 C 10 58.652344 11.347656 60 13 60 L 53 60 C 54.652344 60 56 58.652344 56 57 L 56 7 C 56 5.347656 54.652344 4 53 4 Z M 24 6 L 53 6 C 53.550781 6 54 6.449219 54 7 L 54 57 C 54 57.550781 53.550781 58 53 58 L 13 58 C 12.449219 58 12 57.550781 12 57 L 12 18 L 21 18 C 22.652344 18 24 16.652344 24 15 Z M 22 6.5 L 22 15 C 22 15.550781 21.550781 16 21 16 L 12.5 16 C 12.605469 15.835938 12.734375 15.679688 12.878906 15.535156 L 21.535156 6.878906 C 21.679688 6.738281 21.835938 6.613281 22 6.5 Z M 21 22 C 20.449219 22 20 22.449219 20 23 C 20 23.550781 20.449219 24 21 24 L 37 24 C 37.550781 24 38 23.550781 38 23 C 38 22.449219 37.550781 22 37 22 Z M 41 22 C 40.449219 22 40 22.449219 40 23 C 40 23.550781 40.449219 24 41 24 L 45 24 C 45.550781 24 46 23.550781 46 23 C 46 22.449219 45.550781 22 45 22 Z M 21 26 C 20.449219 26 20 26.449219 20 27 C 20 27.550781 20.449219 28 21 28 L 41 28 C 41.550781 28 42 27.550781 42 27 C 42 26.449219 41.550781 26 41 26 Z M 21 32 C 20.449219 32 20 32.449219 20 33 C 20 33.550781 20.449219 34 21 34 L 43 34 C 43.550781 34 44 33.550781 44 33 C 44 32.449219 43.550781 32 43 32 Z M 21 36 C 20.449219 36 20 36.449219 20 37 C 20 37.550781 20.449219 38 21 38 L 33 38 C 33.550781 38 34 37.550781 34 37 C 34 36.449219 33.550781 36 33 36 Z M 15 50 C 14.449219 50 14 50.449219 14 51 L 14 53 C 14 53.550781 14.449219 54 15 54 C 15.550781 54 16 53.550781 16 53 L 16 51 C 16 50.449219 15.550781 50 15 50 Z M 20 50 C 19.449219 50 19 50.449219 19 51 L 19 53 C 19 53.550781 19.449219 54 20 54 C 20.550781 54 21 53.550781 21 53 L 21 51 C 21 50.449219 20.550781 50 20 50 Z M 25 50 C 24.449219 50 24 50.449219 24 51 L 24 53 C 24 53.550781 24.449219 54 25 54 C 25.550781 54 26 53.550781 26 53 L 26 51 C 26 50.449219 25.550781 50 25 50 Z M 30 50 C 29.449219 50 29 50.449219 29 51 L 29 53 C 29 53.550781 29.449219 54 30 54 C 30.550781 54 31 53.550781 31 53 L 31 51 C 31 50.449219 30.550781 50 30 50 Z M 35 50 C 34.449219 50 34 50.449219 34 51 L 34 53 C 34 53.550781 34.449219 54 35 54 C 35.550781 54 36 53.550781 36 53 L 36 51 C 36 50.449219 35.550781 50 35 50 Z M 40 50 C 39.449219 50 39 50.449219 39 51 L 39 53 C 39 53.550781 39.449219 54 40 54 C 40.550781 54 41 53.550781 41 53 L 41 51 C 41 50.449219 40.550781 50 40 50 Z M 45 50 C 44.449219 50 44 50.449219 44 51 L 44 53 C 44 53.550781 44.449219 54 45 54 C 45.550781 54 46 53.550781 46 53 L 46 51 C 46 50.449219 45.550781 50 45 50 Z M 50 50 C 49.449219 50 49 50.449219 49 51 L 49 53 C 49 53.550781 49.449219 54 50 54 C 50.550781 54 51 53.550781 51 53 L 51 51 C 51 50.449219 50.550781 50 50 50 Z"
                                                fill="rgba(var(--vs-primary), 1)"></path>
                                        </g>
                                    </svg>
                                    <feather-icon icon="ImageIcon" svgClasses="h-6 w-6"
                                                  v-if="itemSelected.type === 'image'"/>
                                    <div class="text-center ml-4 whitespace-no-wrap overflow-hidden"
                                         style="max-width: 150px; text-overflow: ellipsis; ">
                                            <span
                                                class="text-md font-bold">{{
                                                    itemSelected.name
                                                }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="vx-col w-full mt-2">
                                <div v-if="itemSelected.type === 'image'" id="image-preview"
                                     class="vs-con-loading__container">
                                    <img :src="'https://file2.inviv.vn/' + itemSelected.url" alt=""
                                         @load="onloadImagePreview()" class="w-full h-auto rounded-lg">
                                </div>
                            </div>
                            <div class="vx-col w-full">
                                <vs-divider/>
                                <h5>Who has access</h5>
                                <!--                                <div class="mt-2" v-for="(user, index) in itemSelected.users" :key="index">-->
                                <!--                                    <vx-tooltip class="position-icon" :text="user.display_name" position="top">-->
                                <!--                                        <img :src="user.avatar" alt="" class="rounded-full" width="30px" height="30px">-->
                                <!--                                    </vx-tooltip>-->
                                <!--                                </div>-->
                                <div class="mt-4" v-for="(user, index) in itemSelected.users" :key="index">
                                    <div class="flex items-center gap-3 w-ful">
                                        <img :src="user.avatar" alt="" class="rounded-full" width="40px" height="40px">
                                        <div class="vx-row w-full flex items-center">
                                            <div class="vx-col w-3/4">
                                                <p class="font-semibold">{{ user.display_name }}</p>
                                                <p v-if="user.id === itemSelected.owner_id">{{ user.email }}</p>
                                                <div v-else class="flex">
                                                    <vs-checkbox v-model="user.entry_permissions.view"
                                                                 @input="changePermission(user)">
                                                        View
                                                    </vs-checkbox>
                                                    <vs-checkbox v-model="user.entry_permissions.download"
                                                                 @input="changePermission(user)">
                                                        Download
                                                    </vs-checkbox>
                                                    <vs-checkbox v-model="user.entry_permissions.edit"
                                                                 @input="changePermission(user)">
                                                        Edit
                                                    </vs-checkbox>
                                                </div>
                                            </div>
                                            <div class="vx-col w-1/4" v-if="user.id === itemSelected.owner_id">
                                                <h5>Owner</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mt-2">
                                <h6 class="text-primary hover:font-semibold hover:underline cursor-pointer"
                                    @mousedown.stop="openPopupShare">Manage Access</h6>
                                <vs-divider/>
                                <h5>Properties</h5>
                            </div>
                            <div class="vx-col w-full font-medium mt-4">
                                <p class="text-primary">Size: </p>
                                <span>{{
                                        (itemSelected.file_size < 1024) ? '1 KB' : ((1048576 > itemSelected.file_size) && (itemSelected.file_size >= 1024)) ? ((itemSelected.file_size / 1024).toFixed(2) + ' KB') : ((1073741824 > itemSelected.file_size) && (itemSelected.file_size >= 1048576)) ? ((itemSelected.file_size / 1048576).toFixed(2) + ' MB') : (itemSelected.file_size >= 1073741824) ? ((itemSelected.file_size / 1073741824).toFixed(2) + ' GB') : '...'
                                    }}</span>
                            </div>
                            <div class="vx-col w-full font-medium mt-6">
                                <p class="text-primary">Type: </p>
                                <span>{{ capitalizeFirstLetter(itemSelected.type) }}</span>
                            </div>
                            <div class="vx-col w-full font-medium mt-6">
                                <p class="text-primary">Created at: </p>
                                <span>{{ itemSelected.createdDateStr }}</span>
                            </div>
                            <div class="vx-col w-full font-medium mt-6">
                                <p class="text-primary">Date modified: </p>
                                <span>{{ itemSelected.modifiedDateStr }}</span>
                            </div>
                        </VuePerfectScrollbar>
                        <div v-else class="flex h-full items-center justify-center">
                            <div class="text-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                     stroke-linejoin="round"
                                     class="vue-feather mb-3 inline-block text-gray-500 feather feather-eye-off">
                                    <path
                                        d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                                    <line x1="1" y1="1" x2="23" y2="23"></line>
                                </svg>
                                <small class="block text-xs text-gray-500">
                                    There is nothing to preview.
                                </small></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed select-none overflow-hidden bg-white shadow-lg context-menu-folder"
             :style="{top: screenY + 'px', left: screenX + 'px'}" style="z-index: 55000" v-if="isContextMenu">
            <div class="px-12 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="openUploadFile">
                <feather-icon icon="UploadCloudIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.uploadFile') }}</span>
            </div>
            <div class="px-12 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="openPopupCreateFolder">
                <feather-icon icon="FolderPlusIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.createFolder') }}</span>
            </div>
        </div>
        <div class="fixed overflow-hidden bg-white shadow-lg context-menu-folder"
             :style="{top: screenY + 'px', left: screenX + 'px'}" style="z-index: 55000" v-if="isListFunction">
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="openPopupUpdate" v-if="baseItem !== 5">
                <feather-icon icon="Edit2Icon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.rename') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="openPopupShare" v-if="baseItem !== 5">
                <feather-icon icon="LinkIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.share') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="makeACopy" v-if="baseItem !== 5">
                <feather-icon icon="CopyIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.duplicate') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="downloadItem" v-if="baseItem !== 5">
                <feather-icon icon="DownloadCloudIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.download') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="isListFunction = false; isInfo = true" v-if="baseItem !== 5">
                <feather-icon icon="EyeIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.details') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="openPopupMove" v-if="baseItem !== 5">
                <feather-icon icon="CornerDownRightIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.move') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="addToStarred" v-if="baseItem !== 5 && itemSelected.tags.length === 0">
                <feather-icon icon="StarIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.addToStarred') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="removeFromStarred" v-if="baseItem !== 5 && itemSelected.tags.length > 0">
                <feather-icon icon="StarIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.removeFromStarred') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="confirmDeleteItem" v-if="baseItem !== 5">
                <feather-icon icon="Trash2Icon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.moveToTrash') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="confirmRestore" v-if="baseItem === 5">
                <feather-icon icon="RotateCcwIcon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.restore') }}</span>
            </div>
            <div class="px-10 py-4 cursor-pointer flex items-center hover:text-primary context-menu-item"
                 @mousedown.stop="confirmDeleteItemForever" v-if="baseItem === 5">
                <feather-icon icon="Trash2Icon" class="mr-4" svgClasses="h-6 w-6"/>
                <span class="text-md font-bold">{{ $t('document.delete') }}</span>
            </div>
        </div>

        <vs-popup class="holamundo" title="Lorem ipsum dolor sit amet" :active.sync="popupUpdate" v-if="popupUpdate"
                  id="popup-update">
            <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-between">
                    <div class="flex items-center">
                        <feather-icon icon="Edit2Icon" class="mr-4 text-primary" svgClasses="h-5 w-5"/>
                        <span class="text-lg font-bold">{{ $t('document.update') }}</span>
                    </div>
                    <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                  @click="closePopup"/>
                </div>
                <div class="vx-col w-full mt-4">
                    <div class="flex items-center">
                        <svg width="53px" height="53px" viewBox="0 0 512 512" xml:space="preserve"
                             xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <path
                                d="M463.518,94.909H193.885v-10.37c0-22.908-18.574-41.482-41.482-41.482H48.699  c-22.908,0-41.482,18.574-41.482,41.482v51.852v72.593v217.78c0,22.907,18.574,41.482,41.482,41.482h414.819  c22.908,0,41.482-18.575,41.482-41.482V136.391C505,113.483,486.426,94.909,463.518,94.909z M27.958,84.539  c0-11.435,9.308-20.741,20.741-20.741h103.705c11.433,0,20.741,9.306,20.741,20.741v10.37v20.741h20.741h269.633  c11.433,0,20.741,9.306,20.741,20.741v20.741H27.958v-20.741V84.539z M463.518,447.506H48.699c-11.433,0-20.741-9.307-20.741-20.741  v-217.78v-31.111h456.301v248.892C484.259,438.198,474.952,447.506,463.518,447.506z"
                                fill="rgba(var(--vs-primary), 1)"/>
                        </svg>
                        <div class="vx-row w-full">
                            <div class="vx-col w-full pl-10">
                                <p class="text-md font-bold">{{ itemSelected.name }}</p>
                                <p><span>{{
                                        (itemSelected.file_size < 1024) ? '1 KB' : ((1048576 > itemSelected.file_size) && (itemSelected.file_size >= 1024)) ? ((itemSelected.file_size / 1024).toFixed(2) + ' KB') : ((1073741824 > itemSelected.file_size) && (itemSelected.file_size >= 1048576)) ? ((itemSelected.file_size / 1048576).toFixed(2) + ' MB') : (itemSelected.file_size >= 1073741824) ? ((itemSelected.file_size / 1073741824).toFixed(2) + ' GB') : '...'
                                    }} - {{ itemSelected.modifiedDateStr }}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label">Folder Name</label>
                    <span class="text-danger">*</span>
                    <vs-input class="w-full" v-model="folderInfo.name" v-validate="'required'"
                              name="folderName"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('folderName') }}</span>
                </div>
                <div class="vx-col w-full mt-4 flex justify-between gap-4">
                    <vs-button class="w-full" color="success" @click="saveChanges">Save Changes</vs-button>
                    <vs-button class="w-full" color="danger" type="border" @click="closePopup">Cancel</vs-button>
                </div>
            </div>
        </vs-popup>

        <vs-popup class="holamundo" title="Lorem ipsum dolor sit amet" :active.sync="popupCreateFolder"
                  v-if="popupCreateFolder" id="popup-create-folder">
            <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-between">
                    <div class="flex items-center">
                        <feather-icon icon="FolderPlusIcon" svgClasses="h-6 w-6" class="text-primary"/>
                        <span class="text-lg font-bold ml-2">{{ $t('document.createFolder') }}</span>
                    </div>
                    <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                  @click="closePopup"/>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label">Folder Name</label>
                    <span class="text-danger">*</span>
                    <vs-input class="w-full" v-model="folderInfo.name" v-validate="'required'"
                              name="folderName"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('folderName') }}</span>
                </div>
                <div class="vx-col w-full mt-4 flex justify-between gap-4">
                    <vs-button class="w-full" color="success" @click="saveFolder">Save</vs-button>
                    <vs-button class="w-full" color="danger" type="border" @click="closePopup">Cancel</vs-button>
                </div>
            </div>
        </vs-popup>

        <vs-popup class="holamundo" title="Lorem ipsum dolor sit amet" :active.sync="popupUploadFile"
                  v-if="popupUploadFile" id="popup-upload-file">
            <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-between">
                    <div class="flex items-center">
                        <feather-icon icon="UploadCloudIcon" svgClasses="h-6 w-6" class="text-primary"/>
                        <span class="text-lg font-bold ml-2">{{ $t('document.createFolder') }}</span>
                    </div>
                    <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                  @click="closePopup"/>
                </div>
                <div class="vx-col w-full flex flex-wrap mt-4">
                    <div class="flex justify-center upload">
                        <div class="file-upload" @dragover="dragover" @dragleave="dragleave"
                             @drop="drop">
                            <input ref="fileUpload" type="file" id="imageUpload" multiple
                                   class="hidden" @change="uploadFile()">
                            <div class="">
                                <div class="text-center">
                                    <feather-icon icon="UploadCloudIcon" svgClasses="h-10 w-10 text-primary"/>
                                </div>
                                <div class="text-center button-upload">
                                    <vs-button @click="$refs.fileUpload.click()">Chọn tệp</vs-button>
                                </div>
                                <div class="text-center mt-4">
                                    <label class="file-label text-primary">
                                        <div v-if="isDragging">Nhả để thả tập tin vào đây</div>
                                        <div v-else>Thả tập tin ở đây</div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-files">
                        <vs-table stripe :pagination="files.length > 0" maxItems="4" :data="files"
                                  noDataText="Không có dữ liệu">
                            <template slot="thead">
                                <!--                                <vs-th>-->
                                <!--                                    STT-->
                                <!--                                </vs-th>-->
                                <vs-th>
                                    Name
                                </vs-th>
                                <vs-th>
                                    Actions
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <!--                                    <vs-td>-->
                                    <!--                                        {{ indextr + 1 }}-->
                                    <!--                                    </vs-td>-->

                                    <vs-td class="text-primary">
                                        {{ tr.name }}
                                    </vs-td>

                                    <vs-td>
                                        <div class="flex items-center">
                                            <vx-tooltip class="position-icon" :text="$t('button.delete')"
                                                        position="top">
                                                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                                                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                                              @click="confirmDeleteRecord(tr, indextr)"/>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
                <div class="vx-col w-full mt-4 flex justify-between gap-4">
                    <vs-button class="w-full" color="success" @click="confirmUpload">Save</vs-button>
                    <vs-button class="w-full" color="danger" type="border" @click="closePopup">Cancel</vs-button>
                </div>
            </div>
        </vs-popup>

        <vs-popup class="holamundo" title="Lorem ipsum dolor sit amet" :active.sync="popupShare" v-if="popupShare"
                  id="popup-share">
            <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-between">
                    <div class="flex items-center">
                        <feather-icon icon="LinkIcon" class="mr-4 text-primary" svgClasses="h-5 w-5"/>
                        <span class="text-lg font-bold">{{ $t('document.share') }}</span>
                    </div>
                    <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                  @click="closePopup"/>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label">{{ $t('document.invitePeople') }}</label>
                    <v-select v-model="selectdPeolpe" :options="listUser" label="name" multiple @search="(search, loading) => {loading(true)
      getListUser(search).then(() => loading(false))}">
                        <template #option="{ name, description }">
                            <h5 style="margin: 0">{{ name }}</h5>
                            <em>{{ description }}</em>
                        </template>
                        <template #selected-option="{ name, image }">
                            <div class="flex items-center gap-2">
                                <strong>{{ name }}</strong>
                                <img :src="image" alt="" width="20px" height="20px">
                            </div>
                        </template>
                    </v-select>
                </div>
                <div class="vx-col w-full mt-4">
                    <ul class="centerx">
                        <li>
                            <vs-checkbox v-model="canView" @input="selectPermission(1)">Can view</vs-checkbox>
                        </li>
                        <li>
                            <vs-checkbox v-model="canDownload" @input="selectPermission(2)">Can download</vs-checkbox>
                        </li>
                        <li>
                            <vs-checkbox v-model="canEdit" @input="selectPermission(3)">Can edit</vs-checkbox>
                        </li>
                    </ul>
                </div>
                <vs-divider/>
                <div class="vx-col w-full mt-4">
                    <h6>Who has access</h6>
                    <div class="mt-4" v-for="(user, index) in itemSelected.users" :key="index">
                        <div class="flex items-center gap-3 w-ful">
                            <img :src="user.avatar" alt="" class="rounded-full" width="50px" height="50px">
                            <div class="vx-row w-full flex items-center">
                                <div class="vx-col w-3/4">
                                    <p class="font-semibold">{{ user.display_name }}</p>
                                    <p v-if="user.id === itemSelected.owner_id">{{ user.email }}</p>
                                    <div v-else class="flex">
                                        <vs-checkbox disabled v-model="user.entry_permissions.view">Can view
                                        </vs-checkbox>
                                        <vs-checkbox disabled v-model="user.entry_permissions.download">Can download
                                        </vs-checkbox>
                                        <vs-checkbox disabled v-model="user.entry_permissions.edit">Can edit
                                        </vs-checkbox>
                                    </div>
                                </div>
                                <div class="vx-col w-1/4">
                                    <div v-if="user.id === itemSelected.owner_id">
                                        <h5>Owner</h5>
                                    </div>
                                    <div v-else>
                                        <vx-tooltip class="position-icon" :text="$t('document.unshare')" position="top">
                                            <feather-icon icon="XIcon" class="action-err icon-btn"
                                                          svgClasses="h-5 w-5 cursor-pointer"
                                                          @click="unshare(user)"/>
                                        </vx-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full mt-4 flex justify-between gap-4">
                    <vs-button class="w-full" color="success" @click="shareItem">Share</vs-button>
                    <vs-button class="w-full" color="danger" type="border" @click="closePopup">Cancel</vs-button>
                </div>
            </div>
        </vs-popup>

        <vs-popup class="holamundo" :title="itemSelected.name" fullscreen :active.sync="popupShowFile"
                  v-if="popupShowFile && itemSelected" id="popup-show-file">
            <div class="vx-row h-full">
                <div class="vx-col w-full flex items-center justify-center vs-con-loading__container"
                     style="height: 100%;" id="view-item"
                     v-if="itemSelected.type === 'image' || itemSelected.type === 'video' || itemSelected.type === 'audio'">
                    <img :src="itemSelected.src" alt="" v-if="itemSelected.type === 'image'"
                         style="height: 90%" @load="onloadItem">
                    <video :src="itemSelected.src" v-if="itemSelected.type === 'video'"
                           style="height: 90%;" controls></video>
                    <audio :src="itemSelected.src" v-if="itemSelected.type === 'audio'"
                           style="" class="flex items-center" controls></audio>
                </div>
                <div class="vx-col w-full flex items-center justify-center">
                    <iframe class="w-full h-full"
                            :src="itemSelected.src"
                            frameborder="0"
                            v-if="itemSelected.type === 'spreadsheet' || itemSelected.type === 'powerPoint' ||  itemSelected.type === 'word'"></iframe>
                    <iframe class="w-full h-full" :src="itemSelected.src" frameborder="0"
                            v-if="itemSelected.type === 'pdf'"></iframe>
                </div>
            </div>
        </vs-popup>

        <vs-popup class="holamundo" title="Lorem ipsum dolor sit amet" :active.sync="popupMoveItem"
                  v-if="popupMoveItem && itemSelected" id="popup-move-item">
            <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-between">
                    <div class="flex items-center">
                        <feather-icon icon="Edit2Icon" class="mr-4 text-primary" svgClasses="h-5 w-5"/>
                        <span class="text-lg font-bold">{{ $t('document.move') }}</span>
                    </div>
                    <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                  @click="closePopup"/>
                </div>
                <div class="vx-col w-full p-2 my-4" style="background-color: #E1E1E1; margin-left: 0.25rem">
                    <VuePerfectScrollbar ref="mainSidebarPs"
                                         class="scroll-area--tree-select"
                                         :settings="settings" :key="$vs.rtl">
                        <v-jstree :data="treeSelecteMove" collapse whole-row allow-batch @item-click="itemClickSelect">
                            <template slot-scope="node">
                                <div style="min-width: 150px" class="flex items-center gap-2">
                                    <i role="presentation" class="tree-icon tree-themeicon"></i>
                                    <div>
                                        <span>{{ node.model.text }}</span>
                                    </div>
                                </div>
                            </template>
                        </v-jstree>
                    </VuePerfectScrollbar>
                </div>
                <!--                <div class="vx-col w-full mt-4" v-if="nodeSelectedMove.id">-->
                <!--                    <vs-button icon-pack="feather" icon="icon-plus" type="border" @click="popupCreateFolderInMove = true">{{ $t('document.createFolder') }}</vs-button>-->
                <!--                </div>-->
                <div class="vx-col w-full mt-4 flex justify-between gap-4">
                    <vs-button class="w-full" color="warning" @click="confirmMoveItem" :disabled="checkSelectNode">
                        Move
                    </vs-button>
                    <vs-button class="w-full" color="danger" type="border" @click="closePopup">Cancel</vs-button>
                </div>
            </div>

            <!--            <vs-popup class="holamundo" title="Lorem ipsum dolor sit amet" :active.sync="popupCreateFolderInMove"-->
            <!--                      v-if="popupCreateFolderInMove" id="popup-create-folder-in-move">-->
            <!--                <div class="vx-row">-->
            <!--                    <div class="vx-col w-full flex items-center justify-between">-->
            <!--                        <div class="flex items-center">-->
            <!--                            <feather-icon icon="Edit2Icon" class="mr-4 text-primary" svgClasses="h-5 w-5"/>-->
            <!--                            <span class="text-lg font-bold">{{ $t('document.move') }}</span>-->
            <!--                        </div>-->
            <!--                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"-->
            <!--                                      @click="popupCreateFolderInMove = false"/>-->
            <!--                    </div>-->
            <!--                    <div class="vx-col w-full mt-4">-->
            <!--                        <label class="vs-input&#45;&#45;label">Folder Name</label>-->
            <!--                        <span class="text-danger">*</span>-->
            <!--                        <vs-input class="w-full" v-model="folderInfo.name" v-validate="'required'"-->
            <!--                                  name="folderName"></vs-input>-->
            <!--                        <span class="text-danger text-sm">{{ errors.first('folderName') }}</span>-->
            <!--                    </div>-->
            <!--                    <div class="vx-col w-full mt-4 flex justify-between gap-4">-->
            <!--                        <vs-button class="w-full" color="success" @click="saveFolder">Save</vs-button>-->
            <!--                        <vs-button class="w-full" color="danger" type="border" @click="closePopup">Cancel</vs-button>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </vs-popup>-->
        </vs-popup>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from "moment"
import VJstree from 'vue-jstree'

export default {
    name: "Document",
    components: {
        VuePerfectScrollbar,
        vSelect,
        VJstree
    },

    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            isInfo: false,
            isList: false,
            dataFolder: [],
            itemSelected: null,
            indexSelected: null,
            screenX: null,
            screenY: null,
            isContextMenu: false,
            isListFunction: false,
            popupUpdate: false,
            pageNumber: 1,
            currentPage: 0,
            totalPage: 0,
            totalElements: 0,
            folderNameSearch: null,
            folderInfo: {
                parentId: null,
                name: null,
                id: null,
            },
            popupCreateFolder: false,
            typeFolderOptions: [
                {value: 1, label: 'Cá nhân'},
                {value: 2, label: 'Phòng ban'},
                {value: 3, label: 'Chi nhánh'},
                {value: 4, label: 'Tổ chức'},
            ],
            popupUploadFile: false,
            isDragging: false,
            files: [],
            indexFileDelete: null,
            parentInfo: {
                id: null,
                hash: null
            },
            folderHere: {},
            isCheckBack: false,
            baseItem: 1,
            dataPath: [],
            deletedOnly: false,
            recentOnly: false,
            sharedOnly: false,
            starredOnly: false,
            popupShowFile: false,
            popupShare: false,
            treeData: [],
            listUser: [],
            selectdPeolpe: [],
            canView: false,
            canDownload: false,
            canEdit: false,
            isDeleteForever: false,
            nodeSelected: {
                level: 0,
                id: null,
                hash: null,
            },
            popupMoveItem: false,
            treeSelecteMove: [],
            nodeSelectedMove: null,
            popupCreateFolderInMove: false,
        }
    },

    watch: {
        '$store.state.isUpdateDocument'(val) {
            if (val) {
                this.filter()
                this.$store.commit('UPDATE_DOCUMENT', false)
            }
        }
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },

        checkSelectNode() {
            if (!this.nodeSelectedMove) return true
            if (this.nodeSelectedMove) {
                if (this.nodeSelectedMove.id === this.itemSelected.id) return true
                if (this.nodeSelectedMove.id === this.folderHere.id) return true
                if (!this.nodeSelectedMove.id && !this.folderHere.id) return true
                if (this.nodeSelectedMove.path.includes(this.itemSelected.id)) return true
            }
            return false
        },
    },

    async created() {
        let ftpUser = JSON.parse(localStorage.getItem('ftpUser'))
        if (ftpUser && ftpUser.access_token) {
            await this.getAllFolder()
            this.getListFolder(true)
        }
    },

    methods: {
        clickMouseItem(e, item, ind) {
            if (e.button === 0) {
                // if ((this.itemSelected && item.id !== this.itemSelected.id) || !this.itemSelected) {
                this.itemSelected = item
                this.indexSelected = ind
                if (this.itemSelected.type === 'pdf') this.itemSelected['src'] = 'https://file2.inviv.vn/' + this.itemSelected.url + '?workspaceId=' + this.itemSelected.workspace_id + '&thumbnail=' + this.itemSelected.thumbnail + '#toolbar=0'
                if (this.itemSelected.type === 'spreadsheet' || this.itemSelected.type === 'powerPoint' || this.itemSelected.type === 'word') this.itemSelected['src'] = 'https://view.officeapps.live.com/op/embed.aspx?src=' + 'https://file2.inviv.vn/' + this.itemSelected.url + '?workspaceId=' + this.itemSelected.workspace_id + '&thumbnail=' + this.itemSelected.thumbnail
                if (this.itemSelected.type === 'image' || this.itemSelected.type === 'video' || this.itemSelected.type === 'audio') this.itemSelected['src'] = 'https://file2.inviv.vn/' + this.itemSelected.url
                this.isListFunction = false
                if (this.itemSelected.type === 'image' && this.isInfo) {
                    setTimeout(() => {
                        this.$vs.loading({
                            container: `#image-preview`,
                            scale: 0.6
                        })
                    })
                }
                // }
            }
            if (e.button === 1) {
                this.itemSelected = null
                this.indexSelected = null
                this.isListFunction = false
            }
            if (e.button === 2) {
                this.itemSelected = item
                this.folderInfo = {
                    name: item.name,
                    id: item.id
                }
                this.indexSelected = null
                let availWidth = window.innerWidth
                let availHeight = window.innerHeight
                this.screenX = e.pageX
                this.screenY = e.pageY
                this.screenX = (e.pageX + 260) > availWidth ? (e.pageX - 260) : e.pageX
                if (this.baseItem !== 5) this.screenY = (e.pageY + 395) > availHeight ? (e.pageY - (e.pageY + 395 - availHeight)) : e.pageY
                if (this.baseItem === 5) this.screenY = (e.pageY + 100) > availHeight ? (e.pageY - (e.pageY + 100 - availHeight)) : e.pageY
                this.isListFunction = true
            }
            this.isContextMenu = false
        },

        clickMouseNotItem(e) {
            this.itemSelected = null
            this.indexSelected = null
            this.isListFunction = false
            if (e.button === 2) {
                e.preventDefault()
                let availWidth = window.innerWidth
                let availHeight = window.innerHeight
                this.screenX = (e.pageX + 260) > availWidth ? (e.pageX - 260) : e.pageX
                this.screenY = (e.pageY + 100) > availHeight ? (e.pageY - (e.pageY + 100 - availHeight)) : e.pageY
                this.isContextMenu = true
            } else {
                this.isContextMenu = false
            }
        },

        async openItem(e, item) {
            if (this.baseItem !== 5) {
                if (item.type === 'folder') {
                    this.parentInfo = {
                        id: item.parent_id ? item.parent_id : 0,
                        hash: this.folderHere.hash ? this.folderHere.hash : null
                    }
                    this.folderHere = item
                    this.folderHere.pageId = item.hash
                    this.folderHere.folderId = item.hash
                    this.deletedOnly = false
                    this.sharedOnly = false
                    this.recentOnly = false
                    this.starredOnly = false
                    this.baseItem = 1
                    await this.getDataPath();
                    this.getListFolder(true, false)
                } else if (item.type === 'image' || item.type === 'audio' || item.type === 'video') {
                    this.popupShowFile = true
                    if (item.type === 'image') {
                        setTimeout(() => {
                            this.$vs.loading({
                                container: `#view-item`,
                                scale: 0.6
                            })
                        })
                    }
                } else if (item.type === 'spreadsheet' || item.type === 'pdf' || item.type === 'powerPoint' || item.type === 'word') {
                    this.popupShowFile = true
                } else {
                    return this.$vs.notify({
                        text: 'Không có bản xem trước tập tin!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    });
                }
                if (this.folderHere.id) {
                    this.nodeSelected = {
                        id: this.folderHere.id,
                        hash: this.folderHere.hash,
                    }
                } else {
                    this.nodeSelected = {
                        level: 0,
                        id: null,
                        hash: null,
                    }
                }
            } else {
                this.confirmRestore()
            }
        },

        closePopup() {
            this.itemSelected = null
            this.indexSelected = null
            this.popupUpdate = false
            this.popupCreateFolder = false
            this.popupUploadFile = false
            this.popupShowFile = false
            this.popupShare = false
            this.popupMoveItem = false
            this.selectdPeolpe = []
            this.canView = false
            this.canDownload = false
            this.canEdit = false
        },

        openPopupUpdate() {
            this.$validator.reset()
            this.isListFunction = false
            this.popupUpdate = true
        },

        confirmDeleteItem() {
            this.isListFunction = false
            this.isDeleteForever = false
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc chắn muốn chuyển tệp tin này vào thùng rác không ?`,
                accept: this.deleteItem,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteItem() {
            let paylad = {
                deleteForever: this.isDeleteForever,
                entryIds: [this.itemSelected.id]
            }
            this.$vs.loading()
            this.$file.post('/file-entries/delete', paylad).then(async () => {
                this.$vs.notify({
                    text: 'Xóa thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$vs.loading.close()
                await this.getAllFolder()
                this.getListFolder(true)
            }).catch((err) => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        confirmDeleteItemForever() {
            this.isListFunction = false
            this.isDeleteForever = true
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc chắn muốn xóa vĩnh viễn tệp tin này không ?`,
                accept: this.deleteItem,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        getListFolder(check) {
            let url = `/drive/file-entries?orderBy=updated_at&&page=${this.pageNumber}`
            if (this.folderNameSearch) url = url + `&query=${this.folderNameSearch}`
            // if (this.baseItem === 1) {
            if (this.folderHere.hash) {
                url = url + `&pageId=${this.folderHere.pageId}&folderId=${this.folderHere.folderId}`
            } else {
                url = url + `&pageId=0&folderId=0`
            }
            // }
            if (this.recentOnly) url = url + `&pageId=recent&recentOnly=true`
            if (this.sharedOnly) url = url + `&pageId=shares&sharedOnly=true`
            if (this.starredOnly) url = url + `&pageId=starred&starredOnly=true`
            if (this.deletedOnly) url = url + `&pageId=trash&deletedOnly=true`

            this.$vs.loading();
            this.$file.get(url).then(async res => {
                if (res.data.data && res.data.data.length > 0) {
                    let data = res.data.data.map(el => {
                        el.modifiedDateStr = el.updated_at ? moment(el.updated_at).format('DD/MM/YYYY HH:mm') : null
                        el.createdDateStr = el.created_at ? moment(el.created_at).format('DD/MM/YYYY HH:mm') : null
                        return el
                    })
                    if (check) this.dataFolder = data
                    if (!check) this.dataFolder.push(...data)
                } else {
                    if (check) this.dataFolder = []
                }

                if (this.folderHere.path) {
                    this.isCheckBack = true
                } else {
                    this.isCheckBack = false
                }

                if (this.dataFolder.length > 0) {
                    this.dataFolder.forEach(el => {
                        if (el.type === 'image') {
                            let index = this.dataFolder.indexOf(el)
                            setTimeout(() => {
                                this.$vs.loading({
                                    container: `#image-${index}`,
                                    scale: 0.6
                                })
                            })
                        }
                    })
                }
                this.$vs.loading.close()

                if (check) {
                    this.itemSelected = null
                    this.indexSelected = null
                    this.totalElements = res.data.total
                    this.totalPage = res.data.last_page
                }
            }).catch((err) => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        scrollHandle: function (evt) {
            const {scrollTop, offsetHeight, scrollHeight} = evt.target
            if ((scrollTop + offsetHeight) >= scrollHeight) {
                if (this.pageNumber < this.totalPage) {
                    this.pageNumber += 1
                    this.getListFolder(false)
                }
            }
        },

        openPopupCreateFolder() {
            this.isContextMenu = false
            let ftpUser = JSON.parse(localStorage.getItem('ftpUser'))
            if (!ftpUser) {
                return this.$vs.notify({
                    text: 'Hãy đồng bộ dữ liệu trước khi thao tác!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.$validator.reset()
            this.folderInfo.name = null
            this.folderInfo.parentId = null
            this.popupCreateFolder = true
        },

        async saveFolder(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            this.folderInfo.parentId = this.folderHere.id ? this.folderHere.id : null
            this.$vs.loading()
            this.$file.post('/folders', this.folderInfo).then(async () => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Tạo tệp thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                await this.getAllFolder()
                this.loadCallFolder();
                this.closePopup();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return

            const result = await this.$validator.validateAll()
            if (!result) return

            let payload = {
                initialName: this.itemSelected.name,
                name: this.folderInfo.name
            }

            this.$vs.loading()
            this.$file.put(`/file-entries/${this.folderInfo.id}`, payload).then(async () => {
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Cập nhật tệp thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                await this.getAllFolder()
                this.loadCallFolder()
                this.closePopup()
            }).catch((err) => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        loadCallFolder() {
            this.pageNumber = 1
            this.getListFolder(true)
        },

        showDetailsItem() {
            this.isInfo = !this.isInfo
            if (this.itemSelected && this.itemSelected.type === 'image' && this.isInfo) {
                this.$vs.loading({
                    container: `#image-preview`,
                    scale: 0.6
                })
            }
        },

        openUploadFile() {
            this.isContextMenu = false
            let ftpUser = JSON.parse(localStorage.getItem('ftpUser'))
            if (!ftpUser) {
                return this.$vs.notify({
                    text: 'Hãy đồng bộ dữ liệu trước khi thao tác!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.popupUploadFile = true
        },

        dragover(e) {
            e.preventDefault()
            this.isDragging = true
        },
        dragleave() {
            this.isDragging = false
        },
        drop(e) {
            e.preventDefault()
            this.$refs.fileUpload.files = e.dataTransfer.files
            this.uploadFile()
            this.isDragging = false
        },

        uploadFile() {
            let file = this.$refs.fileUpload.files
            // if (file.size > 200000000) {
            //     return this.$vs.notify({
            //         title: 'Lỗi',
            //         text: 'Kích thước tệp không được vượt quá 200MB',
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle',
            //         color: 'warning'
            //     })
            // }
            this.files.push(...file);
            this.$refs.fileUpload.value = null
        },

        confirmDeleteRecord(file, index) {
            this.indexFileDelete = index
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá tệp ${file.name} không?`,
                accept: this.deleteFile,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteFile() {
            this.files.splice(this.indexFileDelete, 1)
        },

        async confirmUpload() {
            this.isContextMenu = false
            this.$vs.loading()
            for (let el of this.files) {
                await this.uploadMultiFile(el)
            }
            this.$vs.loading.close()

            this.popupUploadFile = false
            this.$vs.notify({
                text: 'Tải lên tệp tin thành công!',
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
            });
            this.files = []
            await this.getAllFolder()
            this.getListFolder(true)
        },

        uploadMultiFile(el) {
            return new Promise((resolve, reject) => {
                let formData = new FormData(), config = {};
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };

                formData.append('file', el)
                formData.append('parentId', this.folderHere.id ? this.folderHere.id : null)
                this.$file.post('/uploads', formData, config).then(() => {
                    resolve()
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        async checkAuth() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let payloadLogin = {
                email: userInfo.email,
                password: 'Y@97ygLe7uC@EPex',
                password_confirmation: 'Y@97ygLe7uC@EPex',
                token_name: userInfo.email,
                device_name: window.navigator.userAgent
            }
            this.$vs.loading();
            this.$crm.post('/file-folder/login', payloadLogin).then(async res => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Đồng bộ dữ liệu thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                localStorage.setItem('ftpUser', JSON.stringify(res.data.user))
                await this.getAllFolder();
                this.getListFolder(true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        goBack() {
            this.dataPath.pop();
            let length = this.dataPath.length;
            if (length > 0) {
                this.folderHere = this.dataPath[length - 1];
                this.folderHere.folderId = this.folderHere && this.folderHere.hash ? this.folderHere.hash : null;
                this.folderHere.pageId = this.folderHere && this.folderHere.hash ? this.folderHere.hash : null;
            } else {
                this.folderHere = {}
            }
            if (length > 1) {
                this.parentInfo = {
                    id: this.dataPath[length - 2].id,
                    hash: this.dataPath[length - 2].hash
                }
            } else {
                this.parentInfo = {
                    id: 0,
                    hash: null
                }
            }
            if (this.folderHere.id) {
                this.nodeSelected = {
                    id: this.folderHere.id,
                    hash: this.folderHere.hash,
                }
            } else {
                this.nodeSelected = {
                    level: 0,
                    id: null,
                    hash: null,
                }
            }
            this.getListFolder(true);
        },

        getDataPath() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$file.get(`https://file2.inviv.vn/api/v1/folders/${this.folderHere.hash}/path`).then(res => {
                    this.dataPath = res.data.path;
                    let length = this.dataPath.length;
                    this.folderHere = this.dataPath[length - 1];
                    this.folderHere.folderId = this.folderHere.hash;
                    this.folderHere.pageId = this.folderHere.hash;
                    if (length > 1) {
                        this.parentInfo = {
                            id: this.dataPath[length - 2].id,
                            hash: this.dataPath[length - 2].hash
                        }
                    } else {
                        this.parentInfo = {
                            id: 0,
                            hash: null
                        }
                    }
                    resolve(res)
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        selectBaseItem(index) {
            this.isContextMenu = false
            this.isListFunction = false
            if (index !== this.baseItem) {
                let ftpUser = JSON.parse(localStorage.getItem('ftpUser'))
                if (!ftpUser) {
                    return this.$vs.notify({
                        text: 'Hãy đồng bộ dữ liệu trước khi thao tác!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                this.folderHere = {}
                this.itemSelected = null
                this.baseItem = index
                switch (index) {
                    case 1:
                        this.deletedOnly = false
                        this.sharedOnly = false
                        this.recentOnly = false
                        this.starredOnly = false
                        this.nodeSelected = {
                            level: 0,
                            id: null,
                            hash: null
                        }
                        break
                    case 2:
                        this.deletedOnly = false
                        this.sharedOnly = false
                        this.recentOnly = true
                        this.starredOnly = false
                        break
                    case 3:
                        this.deletedOnly = false
                        this.sharedOnly = true
                        this.recentOnly = false
                        this.starredOnly = false
                        break
                    case 4:
                        this.deletedOnly = false
                        this.sharedOnly = false
                        this.recentOnly = false
                        this.starredOnly = true
                        break
                    case 5:
                        this.deletedOnly = true
                        this.sharedOnly = false
                        this.recentOnly = false
                        this.starredOnly = false
                        break
                }
                this.getListFolder(true)
            }
        },

        confirmRestore() {
            this.isListFunction = false
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Xác nhận khôi phục`,
                text: `Bạn có chắc là muốn khôi phục tệp tin này không ?`,
                accept: this.restoreItem,
                acceptText: this.$t('document.restore'),
                cancelText: "Huỷ"
            })
        },

        restoreItem() {
            let paylad = {
                entryIds: [this.itemSelected.id]
            }
            this.$vs.loading()
            this.$file.post('/file-entries/restore', paylad).then(async () => {
                this.$vs.notify({
                    text: 'Khôi phục thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$vs.loading.close();
                await this.getAllFolder()
                this.getListFolder(true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        addToStarred() {
            this.isListFunction = false
            let payload = {
                entryIds: [this.itemSelected.id]
            }
            this.$vs.loading()
            this.$file.post('/file-entries/star', payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Đánh dấu thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.loadCallFolder()
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        removeFromStarred() {
            this.isListFunction = false
            let payload = {
                entryIds: [this.itemSelected.id]
            }
            this.$vs.loading()
            this.$file.post('/file-entries/unstar', payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Bỏ đánh dấu thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.loadCallFolder()
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        makeACopy() {
            this.isListFunction = false
            let payload = {
                entryIds: [this.itemSelected.id]
            }
            this.$vs.loading()
            this.$file.post('/file-entries/duplicate', payload).then(async () => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Tạo bản sao thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                await this.getAllFolder()
                this.getListFolder(true)
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        onloadImage(item) {
            this.$vs.loading.close(`#${item} > .con-vs-loading`)
        },

        onloadImagePreview() {
            this.$vs.loading.close(`#image-preview > .con-vs-loading`)
        },

        capitalizeFirstLetter(str) {
            return str.replace(/\b\w/g, function (char) {
                return char.toUpperCase();
            });
        },

        getAllFolder() {
            return new Promise((resolve, reject) => {
                let ftpUser = JSON.parse(localStorage.getItem('ftpUser'))
                this.$vs.loading()
                this.$file.get(`/users/${ftpUser.id}/folders?userId=${ftpUser.id}`).then(async res => {
                    if (res.data.folders.length > 0) {
                        let result = res.data.folders.map(el => {
                            el.level = el.path.split('/').length
                            el.children = []
                            return el;
                        }).sort((a, b) => b.level - a.level)
                        await this.buildTree(result)
                    } else {
                        this.treeData = [{
                            text: 'All Files',
                            value: 'All Files',
                            id: null,
                            hash: null,
                            path: null,
                            opened: true,
                            level: 0,
                            icon: "",
                            selected: true,
                            children: []
                        }]
                    }
                    resolve()
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        buildTree(data) {
            return new Promise(async (resolve, reject) => {
                let firstChild = data[0]
                if (firstChild.level > 1) {
                    data.forEach(el => {
                        let listFolder = data.filter(item => item.parent_id === el.id && item.level === firstChild.level).map(item => {
                            // item.title = item.name
                            return {
                                text: item.name,
                                value: item.name,
                                id: item.id,
                                hash: item.hash,
                                path: item.path,
                                level: item.level,
                                children: item.children,
                                icon: "",
                                opened: false,
                            }
                        })
                        return {
                            text: el.name,
                            value: el.name,
                            id: el.id,
                            hash: el.hash,
                            path: el.path,
                            level: el.level,
                            children: el.children.push(...listFolder),
                            icon: "",
                            opened: false,
                        }
                    })
                    let data1 = data.filter(el => el.level < firstChild.level)
                    if (data1.length > 0) await this.buildTree(data1)
                } else {
                    let result = data.map(el => {
                        return {
                            text: el.name,
                            value: el.name,
                            id: el.id,
                            hash: el.hash,
                            path: el.path,
                            level: el.level,
                            children: el.children,
                            icon: "",
                            opened: false,
                        }
                    })
                    this.treeData = [{
                        text: 'All Files',
                        value: 'All Files',
                        id: null,
                        hash: null,
                        path: null,
                        opened: true,
                        level: 0,
                        icon: "",
                        selected: true,
                        children: [...result]
                    }]

                    this.treeSelecteMove = [{
                        text: 'All Files',
                        value: 'All Files',
                        id: null,
                        hash: null,
                        path: null,
                        opened: true,
                        children: [...result]
                    }]
                }
                resolve()
            })
        },

        onloadItem() {
            this.$vs.loading.close(`#view-item > .con-vs-loading`)
        },

        async openPopupShare() {
            this.isListFunction = false
            await this.getListUser()
            this.popupShare = true
        },

        getListUser(query) {
            return new Promise((resolve, reject) => {
                if (!query) this.$vs.loading()

                let url = `/normalized-models/user?perPage=10`
                if (query) url += `&query=${query}`

                this.$file.get(url).then(res => {
                    let ftpUser = JSON.parse(localStorage.getItem('ftpUser'))
                    this.listUser = res.data.results.filter(el => el.id !== ftpUser.id)
                    this.$vs.loading.close();
                    resolve()
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        changeView(isList) {
            if (this.dataFolder.length > 0) {
                this.dataFolder.forEach(el => {
                    if (el.type === 'image') {
                        let index = this.dataFolder.indexOf(el);
                        setTimeout(() => {
                            this.$vs.loading({
                                container: `#image-${index}`,
                                scale: 0.6
                            })
                        })
                    }
                })
            }
            this.isList = isList
        },

        shareItem() {
            if (this.selectdPeolpe.length === 0) {
                return this.$vs.notify({
                    text: 'Hãy chọn ít nhất 1 người để chia sẻ!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            if (!this.canView && !this.canDownload && !this.canEdit) {
                return this.$vs.notify({
                    text: 'Hãy chọn quyền hạn để chia sẻ!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }

            let payload = {}
            payload.emails = this.selectdPeolpe.map(el => el.description)
            payload.permissions = {}
            if (this.canView) payload.permissions['view'] = true
            if (this.canDownload) payload.permissions['download'] = true
            if (this.canEdit) payload.permissions['edit'] = true

            this.$vs.loading()
            this.$file.post(`/file-entries/${this.itemSelected.id}/share`, payload).then(() => {
                this.$vs.loading.close()
                this.closePopup()
                this.$vs.notify({
                    text: 'Chia sẻ tài liệu thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                this.loadCallFolder()
            }).catch((err) => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        unshare(user) {
            let payload = {
                userId: user.id
            }
            this.$vs.loading()
            this.$file.post(`/file-entries/${this.itemSelected.id}/unshare`, payload).then(() => {
                this.$vs.loading.close()
                this.closePopup()
                this.$vs.notify({
                    text: 'Hủy chia sẻ tài liệu thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                this.loadCallFolder()
            }).catch((err) => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        changePermission(user) {
            let payload = {
                permissions: user.entry_permissions,
                userId: user.id
            }

            this.$vs.loading()
            this.$file.post(`/file-entries/${this.itemSelected.id}/change-permissions?_method=PUT`, payload).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Thay đổi quyền thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                this.loadCallFolder()
            }).catch((err) => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        downloadItem() {
            window.open(`https://file2.inviv.vn/api/v1/file-entries/download/${this.itemSelected.hash}?workspaceId=0`, '_blank')
        },

        async itemClick(node) {
            this.nodeSelected = node.model
            if (this.nodeSelected.level) {
                this.folderHere.hash = this.nodeSelected.hash
                await this.getDataPath()
            } else {
                this.parentInfo = {
                    id: 0,
                    hash: null
                }
                this.folderHere = {}
                this.dataPath = []
            }
            this.loadCallFolder()
        },

        openPopupMove() {
            this.isListFunction = false
            this.popupMoveItem = true
        },

        itemClickSelect(node) {
            this.nodeSelectedMove = node.model
        },

        confirmMoveItem() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Xác nhận di chuyển`,
                text: `Bạn có chắc là muốn đi chuyển tệp tin này không?`,
                accept: this.moveItem,
                acceptText: this.$t('document.move'),
                cancelText: "Huỷ"
            })
        },

        moveItem() {
            let payload = {
                entryIds: [this.itemSelected.id],
                destinationId: this.nodeSelectedMove.id
            }

            this.$vs.loading()

            this.$file.post('/file-entries/move', payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Di chuyển tệp tin thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.closePopup()
                this.loadCallFolder()
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        selectPermission(index) {
            if ((this.canDownload || this.canEdit) && !this.canView && (index === 2 || index === 3)) this.canView = true
            if (!this.canView && index === 1) {
                this.canDownload = false
                this.canEdit = false
            }
        },
    },
}
</script>

<style lang="scss">
#document {
    height: calc(var(--vh, 1vh) * 100 - 127px);
    -webkit-touch-callout: none; /* Safari */
    -webkit-user-select: none; /* Safari 3.1+ */
    -khtml-user-select: none; /* Konqueror 4.0+ */
    -moz-user-select: none; /* Firefox 0.8+ */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */

    .height-full {
        height: 100%;

        .left-col .menu {
            background-color: #F4F5F6;
            border-right: solid 1px #cdcdcd;
            border-radius: 0.5rem 0 0 0.5rem;
            padding-top: 14px;
            margin-left: 0;

            .base {
                height: calc(var(--vh, 1vh) * 100 - 179px);

                .vs-collapse {
                    .vs-collapse-item--header {
                        padding: 1rem 0.75rem;
                    }

                    .vs-collapse-item--content {
                        .con-content--item {
                            padding: 1rem 0;

                            .base-item {
                                border-radius: 0.25rem;
                            }

                            .base-item:hover {
                                background-color: rgba(var(--vs-primary), .2);
                            }

                            .base-item-active {
                                border-radius: 0.25rem;
                                background-color: rgba(var(--vs-primary), .2);
                            }

                            .scroll-area--navigator {
                                height: calc(var(--vh, 1vh) * 100 - 540px);
                            }
                        }
                    }
                }
            }
        }

        .right-col {
            padding: 1rem;

            .function-folder {
                border-bottom: solid 1px #cdcdcd;
                margin-right: 0;
                padding-bottom: 12px
            }

            .list-folder {
                height: calc(var(--vh, 1vh) * 100 - 190px);

                .scroll-view-folder {
                    max-height: calc(var(--vh, 1vh) * 100 - 210px)
                }

                .item-list {
                    padding-inline: 2rem;
                    border-radius: 0.75rem;

                    img {
                        max-width: 53px;
                        max-height: 53px;
                    }
                }

                .item-list:hover {
                    background-color: #F4F5F6;

                    svg path {
                        fill: rgba(var(--vs-primary), 1)
                    }
                }

                .item-folder {
                    border-radius: 0.75rem;

                    img {
                        max-width: 80px;
                        max-height: 80px;
                    }
                }

                .item-folder:hover {
                    background-color: #F4F5F6;

                    svg path {
                        fill: rgba(var(--vs-primary), 1)
                    }
                }

                .info-file {
                    border-left: solid 1px #cdcdcd;
                    margin: 0 -1rem;
                }

                .selectItem {
                    background-color: #F4F5F6;

                    svg path {
                        fill: rgba(var(--vs-primary), 1)
                    }
                }
            }
        }
    }

    .context-menu-folder {
        border-radius: 1rem;
        width: 260px;

        .context-menu-item:hover {
            background-color: #F4F5F6;
        }
    }

    .node-tree-document-no-selected {
        border-radius: 0.25rem;
    }

    .node-tree-document-no-selected:hover {
        color: rgba(var(--vs-primary), 1);
        background-color: rgba(var(--vs-primary), .4);
    }

    .node-tree-document-selected {
        border-radius: 0.25rem;
        color: rgba(var(--vs-primary), 1);
        background-color: rgba(var(--vs-primary), .4);
    }
}

#popup-update,
#popup-create-folder,
#popup-upload-file,
#popup-share,
#popup-move-item,
#popup-create-folder-in-move {
    .vs-popup--header {
        display: none;
    }
}

#popup-upload-file {
    .upload {
        .file-upload {
            width: 200px;
            height: 200px;
            border: dashed 2px rgba(var(--vs-primary), 1);
            border-radius: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;

            .button-upload button {
                border-radius: 1.5rem;
            }

            .file-label {
                color: #C0C0C0;
            }
        }
    }
}

@media (min-width: 1340px) {
    #popup-upload-file {
        .vs-popup {
            width: 50% !important;
        }

        .table-files {
            width: calc(100% - 210px);
            margin-left: 10px;
        }
    }
}

@media screen and (max-width: 1339px) {
    #popup-upload-file {

        .upload {
            width: 100%;
        }

        .table-files {
            width: 100%;
            margin-top: 10px;
        }
    }
}

.con-vs-dialog {
    z-index: 54000;
}


.list-folder .con-vs-loading {
    z-index: 50000;
}

#popup-show-file {
    .vs-popup--content {
        height: 100%;
    }
}

#popup-move-item {
    .scroll-area--tree-select {
        height: calc(var(--vh, 1vh) * 100 - 600px);
    }

    .tree-wholerow-clicked,
    .tree-wholerow-hovered {
        border-radius: 0.25rem;
        background-color: rgba(var(--vs-primary), .4) !important;
        z-index: 0;
    }

    .tree-selected,
    .tree-hovered {
        color: rgba(var(--vs-primary), 1) !important;
        z-index: 0;
    }
}

//.tree-node:has(> .tree-wholerow-hovered) > .tree-wholerow {
//    border-radius: 0.25rem;
//    background-color: rgba(var(--vs-primary), .4) !important;
//}

#vs-popup--content {
    .con-vs-popup {
        z-index: 54000 !important;
    }
}

#popup-share {
    .vs__dropdown-menu {
        max-height: 250px !important;
    }
}

</style>


